/**
 * Tunisian Arabic (Derja), Arabic script, used for notifications, UI and support tone.
 * Pending native-speaker review (PLAN Q-I1).
 */
export const aeb = {
    'brand.name': 'beinstore',
    'email.footer.automated': 'الإيمايل هذا تبعث وحدو من {brand}. ما تجاوبش عليه.',
    'email.signInCode.subject': 'الكود متاعك باش تدخل لـ {brand}: {code}',
    'email.signInCode.heading': 'الكود متاع الدخول',
    'email.signInCode.intro': 'استعمل الكود هذا باش تدخل لـ {brand}:',
    'email.signInCode.expiry': 'يوفى بعد {minutes, plural, zero {# دقيقة} one {دقيقة} two {دقيقتين} few {# دقايق} many {# دقيقة} other {# دقيقة}} وما يتستعملش كان مرة وحدة.',
    'email.signInCode.ignore': 'كان موش انت اللي طلبتو، ما تعمل شي: حتى حد ما ينجم يدخل من غير الكود هذا.',
    'email.signInCode.neverShare': 'فريق {brand} عمرو ما يطلب منك الكود هذا.',
    'email.order.subject': 'الكوموند نومرو {number} تأكدت – {store}',
    'email.order.heading': 'يعيشك على الكوموند',
    'email.order.intro': '{store} وصلتو الكوموند متاعك نومرو {number}:',
    'email.order.line': '{title} — العدد {quantity}: {amount}',
    'email.order.cashOnDelivery': 'الخلاص كي توصلك: حضّر المبلغ الكل.',
    'email.order.bankTransfer': 'الخلاص بفيرمون بنكي: {instructions}',
    'email.order.shipping': 'التوصيل لـ: {address}',
    'email.order.pickup': 'تهزها من البوتيك: البوتيك باش تكلمك كي تكون الكوموند حاضرة.',
    'email.newOrder.subject': 'كوموند جديدة نومرو {number} ({total})',
    'email.newOrder.heading': 'كوموند جديدة',
    'email.newOrder.intro': '{customer} عمل الكوموند نومرو {number} بـ {total} في {store}.',
    'email.newOrder.action': 'شوف الكوموند',
    'admin.language': 'اللغة',
    'admin.language.ar': 'العربية',
    'admin.language.aeb': 'تونسي',
    'admin.language.fr': 'Français',
    'admin.language.en': 'English',
    'admin.nav.home': 'الدار',
    'admin.nav.account': 'الحساب متاعي',
    'admin.nav.security': 'الأمان',
    'admin.nav.signOut': 'اخرج',
    'admin.nav.label': 'القايمة الرئيسية',
    'admin.nav.skip': 'إمشي للمحتوى',
    'admin.nav.viewStore': 'شوف البوتيك',
    'admin.nav.store': 'تنقّل البوتيك',
    'admin.nav.menu': 'حلّ القائمة',
    'admin.nav.closeMenu': 'سكّر القائمة',
    'admin.nav.storeHome': 'نظرة عامة',
    'admin.nav.group.sales': 'المبيعات',
    'admin.nav.group.catalog': 'الكتالوج',
    'admin.nav.group.online': 'البوتيك على النت',
    'admin.nav.group.fulfilment': 'التوصيل والفلوس',
    'admin.nav.group.settings': 'الإعدادات',
    'admin.auth.tagline': 'سيّر بوتيكك على النت، من الكوموند لين الفلوس.',
    'admin.auth.point.orders': 'الكوموندات والتوصيل والخلاص عند الاستلام في بلاصة وحدة',
    'admin.auth.point.languages': 'بوتيك بالعربي والفرنساوي والتونسي والإنقليزي',
    'admin.auth.point.secure': 'دخول بكود في الإيمايل، والتحقق المزدوج كان تحب',
    'admin.loading': 'قاعد يتحمّل…',
    'admin.save': 'سجّل',
    'admin.saved': 'التبديلات تسجلت.',
    'admin.copy': 'انسخ',
    'admin.copied': 'تنسخ',
    'admin.download': 'نزّل',
    'admin.loadMore': 'وريني أكثر',
    'storefront.reviews.title': 'آراء الحرفاء',
    'storefront.reviews.storeTitle': 'آراء على البوتيك',
    'storefront.reviews.count': '{count, plural, one {رأي واحد} other {# آراء}}',
    'storefront.reviews.average': '{average} من 5',
    'storefront.reviews.stars': '{rating} نجوم من 5',
    'storefront.reviews.bar': '{stars} نجوم: {count}',
    'storefront.reviews.empty': 'مازال ما فما حتى رأي.',
    'storefront.reviews.verified': 'شراء متحقق منو',
    'storefront.reviews.anonymous': 'حريف متحقق منو',
    'storefront.reviews.reply': 'ردّ البوتيك',
    'storefront.reviews.pages': 'صفحات الآراء',
    'storefront.review.title': 'قلّنا رأيك',
    'storefront.review.intro': 'رأيك يتنشر بعد ما البوتيك توافق عليه.',
    'storefront.review.store': 'البوتيك (الخدمة، التوصيل…)',
    'storefront.review.rating': 'تقييمك',
    'storefront.review.star': '{count, plural, one {نجمة وحدة} other {# نجوم}}',
    'storefront.review.comment': 'تعليقك (كان تحب)',
    'storefront.review.name': 'إسمك (يبان مع الرأي)',
    'storefront.review.submit': 'إبعث رأيي',
    'storefront.review.sent': 'يعيشك! رأيك باش يتنشر بعد الموافقة.',
    'storefront.review.done': 'الرأي تبعث',
    'storefront.review.error.already-reviewed': 'عطيت رأيك قبل.',
    'storefront.review.error.review-not-open': 'تنجم تعطي رأيك كي توصلك الكوموند.',
    'storefront.review.error.generic': 'رأيك ما تبعثش. ثبّت في الخانات وعاود.',
    'storefront.comment.link': 'خلّي تعليق',
    'storefront.comment.title': 'تعليق للبوتيك',
    'storefront.comment.intro': 'عندك فكرة ولا ملاحظة؟ الميساج متاعك يمشي للبوتيك وما يتنشرش.',
    'storefront.comment.message': 'الميساج متاعك',
    'storefront.comment.send': 'إبعث',
    'storefront.comment.sent': 'يعيشك، الميساج متاعك تبعث للبوتيك.',
    'storefront.comment.error': 'الميساج ما تبعثش. عاود من بعد.',
    'admin.reviews.title': 'آراء الحرفاء',
    'admin.reviews.empty': 'مازال ما فما حتى رأي.',
    'admin.reviews.search': 'لوّج (نص ولا إسم)',
    'admin.reviews.subject': 'على',
    'admin.reviews.subject.product': 'منتوج',
    'admin.reviews.subject.store': 'البوتيك',
    'admin.reviews.rating': 'التقييم',
    'admin.reviews.stars': '{rating} من 5',
    'admin.reviews.status': 'الحالة',
    'admin.reviews.status.pending': 'يستنّى الموافقة',
    'admin.reviews.status.approved': 'منشور',
    'admin.reviews.status.hidden': 'مخبّي',
    'admin.reviews.filter.allStatuses': 'الحالات الكل',
    'admin.reviews.filter.allSubjects': 'المنتوجات والبوتيك',
    'admin.reviews.filter.allRatings': 'التقييمات الكل',
    'admin.reviews.column.date': 'التاريخ',
    'admin.reviews.column.review': 'الرأي',
    'admin.reviews.column.author': 'الحريف',
    'admin.reviews.order': 'الكوموند نومرو {number}',
    'admin.reviews.open': 'حلّ الرأي متاع {date}',
    'admin.reviews.anonymous': 'حريف (المعطيات تفسخت)',
    'admin.reviews.noComment': 'بلاش تعليق',
    'admin.reviews.approve': 'انشر',
    'admin.reviews.hide': 'خبّي',
    'admin.reviews.reply': 'ردّ قدّام الناس',
    'admin.reviews.replyLabel': 'الردّ متاعك',
    'admin.reviews.replyHint': 'يبان تحت الرأي في البوتيك على النت.',
    'admin.reviews.saveReply': 'سجّل الردّ',
    'admin.reviews.removeReply': 'فسّخ الردّ',
    'admin.reviews.saved': 'الرأي تبدّل.',
    'admin.reviews.error.version-conflict': 'الرأي تبدّل في الأثناء. عاود حمّل الصفحة.',
    'admin.reviews.pending': '{count, plural, one {رأي واحد يستنّى} other {# آراء يستنّاو}}',
    'admin.reviews.summary.store': 'البوتيك',
    'admin.reviews.summary.products': 'المنتوجات',
    'admin.reviews.summary.average': '{average}/5 · {count, plural, one {رأي منشور} other {# آراء منشورة}}',
    'admin.reviews.summary.none': 'مازال ما فما حتى رأي منشور',
    'admin.reviews.language': 'اللغة',
    'admin.comments.title': 'التعليقات',
    'admin.comments.intro': 'ميساجات خاصة خلّاوها اللي زاروا البوتيك على النت.',
    'admin.comments.empty': 'مازال ما فما حتى تعليق.',
    'admin.comments.search': 'لوّج في الميساجات',
    'admin.comments.status': 'الحالة',
    'admin.comments.status.new': 'جديد',
    'admin.comments.status.handled': 'تعمل',
    'admin.comments.filter.allStatuses': 'الكل',
    'admin.comments.column.message': 'الميساج',
    'admin.comments.markHandled': 'علّم إلّي تعمل',
    'admin.comments.reopen': 'حلّ من جديد',
    'admin.feedback.button': 'رأيك',
    'admin.feedback.title': 'رأيك في beinstore',
    'admin.feedback.intro': 'عندك اقتراح ولا مشكلة؟ فريق beinstore يقرا كل ميساج.',
    'admin.feedback.rating': 'تقييمك',
    'admin.feedback.category': 'الموضوع',
    'admin.feedback.category.suggestion': 'اقتراح',
    'admin.feedback.category.problem': 'مشكلة',
    'admin.feedback.category.other': 'حاجة أخرى',
    'admin.feedback.message': 'الميساج متاعك',
    'admin.feedback.send': 'إبعث',
    'admin.feedback.sent': 'يعيشك على رأيك!',
    'admin.feedback.close': 'سكّر',
    'admin.feedback.star': '{count, plural, one {نجمة وحدة} other {# نجوم}}',
    'admin.operator.feedback.title': 'آراء التجّار',
    'admin.operator.feedback.average': 'معدّل التقييم: {average}/5 ({count, plural, one {رأي واحد} other {# آراء}})',
    'admin.operator.feedback.empty': 'مازال ما فما حتى رأي.',
    'admin.operator.feedback.author': 'التاجر',
    'admin.operator.feedback.store': 'البوتيك',
    'admin.operator.feedback.page': 'الصفحة',
    'admin.operator.feedback.allCategories': 'المواضيع الكل',
    'admin.operator.watch.title': 'العروض',
    'admin.operator.watch.intro': 'راقب كلمات في كاتالوغ كل حانوت. أخفي عرض ولا وقّف الحانوت كان ما هوش مسموح.',
    'admin.operator.watch.terms': 'الكلمات المراقبة',
    'admin.operator.watch.termsHint': 'كلمة في كل سطر، 4 حروف على الأقل. نلقاوها في العنوان والوصف والعنوان والوسوم.',
    'admin.operator.watch.termsSave': 'سجّل القائمة',
    'admin.operator.watch.termsSaved': 'تسجّلت قائمة المراقبة.',
    'admin.operator.watch.suggest': 'زيد كلمات مقترحة',
    'admin.operator.watch.flags': 'عروض مطابقة',
    'admin.operator.watch.recent': 'آخر العروض',
    'admin.operator.watch.empty': 'ما فما حتى تطابق مع القائمة.',
    'admin.operator.watch.noTerms': 'سجّل كلمات مراقبة باش تشوف العروض.',
    'admin.operator.watch.matched': 'تطابق',
    'admin.operator.watch.hide': 'خبّي العرض',
    'admin.operator.watch.confirmHide': 'تخبّي العرض هذا؟',
    'admin.operator.watch.hidden': 'تخبّى العرض.',
    'admin.operator.watch.suspend': 'وقّف الحانوت',
    'admin.operator.watch.confirmSuspend': 'توقّف الحانوت هذا؟',
    'admin.operator.watch.suspended': 'توقّف الحانوت.',
    'admin.operator.watch.resume': 'حلّ الحانوت',
    'admin.operator.watch.resumed': 'تحلّ الحانوت.',
    'admin.operator.watch.reason': 'السبب',
    'admin.operator.watch.open': 'حلّ العرض',
    'admin.operator.watch.store': 'الحانوت',
    'admin.operator.watch.product': 'العرض',
    'admin.operator.watch.search': 'فتّش في العروض',
    'admin.operator.watch.actions': 'إجراءات',
    'admin.operator.merchants': 'التجّار',
    'admin.operator.merchants.intro': 'كل كونت مالك والبوتيكات اللي يصرّفهم. لوّج ولا صفّي ولا صدّر ولا جب الهوية برك — الملف ما يصنعش بوتيك.',
    'admin.operator.merchants.search': 'لوّج بالإيميل والا الاسم والا البوتيك',
    'admin.operator.merchants.empty': 'ما فما حتى تاجر.',
    'admin.operator.merchants.stores': 'البوتيكات',
    'admin.operator.merchants.stores.any': 'أي عدد',
    'admin.operator.merchants.stores.one': 'بوتيك واحد',
    'admin.operator.merchants.stores.several': 'برشا بوتيكات',
    'admin.operator.merchants.presence': 'حالة البوتيك',
    'admin.operator.merchants.presence.any': 'أي حالة',
    'admin.operator.merchants.presence.unpublished': 'عندو بوتيك مش منشور',
    'admin.operator.merchants.presence.suspended': 'عندو بوتيك موقّف',
    'admin.operator.merchants.presence.live': 'عندو بوتيك خدّام',
    'admin.operator.merchants.storeCount': 'البوتيكات',
    'admin.operator.merchants.created': 'تاريخ الإنشاء',
    'admin.operator.merchants.card': 'التاجر',
    'admin.operator.merchants.otherStores': 'بوتيكات أخرين:',
    'admin.operator.merchants.noName': 'بلا اسم ظاهر',
    'admin.operator.merchants.csv': 'التوريد والتصدير',
    'admin.operator.merchants.export': 'صدّر (CSV)',
    'admin.operator.merchants.import': 'ورّد ملف CSV',
    'admin.operator.merchants.importHint': 'الأعمدة: email (لازم)، display_name، preferred_locale. الملف يتفحص أول وما يتكتب شيء قبل ما تؤكد. ما يصنعش بوتيكات وما يبعثش إيميل.',
    'admin.operator.merchants.importSummary': '{created} باش يتخلقوا و{updated} باش يتبدّلوا. حتى بوتيك ما يتخلقش.',
    'admin.operator.merchants.importDone': 'التوريد كمّل: {created} تخلقوا و{updated} تبدّلوا.',
    'admin.operator.merchants.importError.duplicate-email': 'الإيميل هذا مكرّر في الملف.',
    'admin.operator.merchants.importError.operator-account': 'العنوان هذا متاع مشغّل المنصة. ما ينجمش يملك بوتيك.',
    'admin.grid.pagination': 'الصفحات',
    'admin.grid.range': '{from}–{to} من {total}',
    'admin.grid.pageSize': 'قداش من سطر في الصفحة',
    'admin.grid.previous': 'الصفحة اللي قبل',
    'admin.grid.next': 'الصفحة اللي بعد',
    'admin.grid.page': 'الصفحة {page}',
    'admin.grid.reset': 'رجّع كيما كان',
    'admin.grid.noResults': 'ما فما حتى نتيجة بالمعايير هاذي.',
    'admin.grid.from': 'من',
    'admin.grid.to': 'لين',
    'admin.grid.filters': 'الفلاتر',
    'admin.order.paymentMethod': 'طريقة الخلاص',
    'admin.order.deliveryMethod': 'طريقة التوصيل',
    'admin.order.filter.allPaymentMethods': 'الطرق الكل متاع الخلاص',
    'admin.order.filter.allDeliveryMethods': 'الطرق الكل متاع التوصيل',
    'admin.inventory.filter.untracked': 'ستوك موش متابَع',
    'admin.discount.search': 'لوّج على كود',
    'admin.discount.state': 'الحالة',
    'admin.discount.state.active': 'ينجم يتستعمل',
    'admin.discount.state.scheduled': 'مبرمج',
    'admin.discount.state.expired': 'وفات مدتو',
    'admin.discount.state.exhausted': 'تكمّل',
    'admin.discount.state.disabled': 'موقّف',
    'admin.discount.filter.allStates': 'الحالات الكل',
    'admin.audit.filter.allActors': 'الناس الكل',
    'admin.audit.filter.action': 'إجراء فيه',
    'admin.error.invalid-code': 'الكود غالط. ثبّت فيه وعاود.',
    'admin.error.code-expired': 'الكود هذا ما عادش صالح. اطلب واحد جديد.',
    'admin.error.too-many-requests': 'برشا محاولات. عاود بعد {seconds, plural, zero {# ثانية} one {ثانية} two {ثانيتين} few {# ثواني} many {# ثانية} other {# ثانية}}.',
    'admin.error.email-unavailable': 'ما نجمناش نبعثو الإيمايل. عاود بعد شوية.',
    'admin.error.unauthenticated': 'الجلسة متاعك وفات. ادخل من جديد.',
    'admin.error.mfa-required': 'ثبّت روحك قبل بالخطوة الثانية.',
    'admin.error.forbidden': 'الدور متاعك ما يسمحلكش تعمل هذا.',
    'admin.error.network': 'مشكل في الكونكسيون. ثبّت في الريزو وعاود.',
    'admin.error.generic': 'صار مشكل. عاود.',
    'admin.signIn.title': 'ادخل لـ {brand}',
    'admin.signIn.intro': 'نبعثولك كود فيه 6 أرقام على الإيمايل. ما تحتاجش كلمة سر.',
    'admin.signIn.email': 'الإيمايل',
    'admin.signIn.sendCode': 'ابعثلي كود',
    'admin.signIn.codeTitle': 'ثبّت في الإيمايل متاعك',
    'admin.signIn.codeIntro': 'اكتب الكود اللي تبعث لـ {email}.',
    'admin.signIn.code': 'الكود (6 أرقام)',
    'admin.signIn.continue': 'كمّل',
    'admin.signIn.changeEmail': 'استعمل إيمايل آخر',
    'admin.signIn.resend': 'ابعثلي كود جديد',
    'admin.mfa.verifyTitle': 'التثبّت بخطوتين',
    'admin.mfa.verifyIntro': 'اكتب الكود اللي ظاهر في تطبيقة المصادقة.',
    'admin.mfa.code': 'كود التطبيقة',
    'admin.mfa.verify': 'ثبّت',
    'admin.mfa.useRecovery': 'استعمل كود احتياطي',
    'admin.mfa.useApp': 'استعمل تطبيقة المصادقة',
    'admin.mfa.recoveryCode': 'الكود الاحتياطي',
    'admin.mfa.setupTitle': 'احمي الحساب متاعك',
    'admin.mfa.setupIntro': 'باش نحميو البوتيك متاعك، كل دخلة تطلب كود من التليفون متاعك. اعمل سكان للـ QR هذا بتطبيقة مصادقة.',
    'admin.mfa.qrAlt': 'QR باش تعملو سكان بتطبيقة المصادقة',
    'admin.mfa.manualKey': 'ما نجمتش تعمل سكان؟ اكتب المفتاح هذا: {secret}',
    'admin.mfa.activate': 'فعّل',
    'admin.mfa.recoveryTitle': 'سجّل الكودات الاحتياطية',
    'admin.mfa.recoveryIntro': 'كل كود يخدم مرة وحدة كان ضيّعت التليفون. خبّيهم في بلاصة آمنة: ما عادش باش يظهرولك.',
    'admin.mfa.recoverySaved': 'سجّلتهم',
    'admin.mfa.recoveryFileName': 'beinstore-recovery-codes.txt',
    'admin.home.title': 'عسلامة {name}',
    'admin.home.titleAnonymous': 'عسلامة',
    'admin.home.stores': 'الحوانت متاعك',
    'admin.home.noStores': 'مازال ما عندك وصول لحتى بوتيك.',
    'admin.home.auditLog': 'سجل العمليات',
    'admin.role.owner': 'المولى',
    'admin.role.admin': 'مدير',
    'admin.role.staff': 'فريق الخدمة',
    'admin.role.support': 'الدعم',
    'admin.storeStatus.active': 'خدّام',
    'admin.storeStatus.suspended': 'موقوف',
    'admin.storeStatus.provisioning': 'مش منشورة',
    'admin.storeStatus.closed': 'مسكّر',
    'admin.account.title': 'الحساب متاعي',
    'admin.account.email': 'الإيمايل',
    'admin.account.displayName': 'الإسم اللي يظهر',
    'admin.account.preferredLocale': 'اللغة اللي تحبها (الإيمايلات والواجهة)',
    'admin.security.title': 'الأمان',
    'admin.security.sessions': 'الجلسات المحلولة',
    'admin.security.thisDevice': 'الجهاز هذا',
    'admin.security.unknownDevice': 'جهاز موش معروف',
    'admin.security.lastActive': 'آخر نشاط: {date}',
    'admin.security.revoke': 'سكّر',
    'admin.security.revokeOthers': 'سكّر الجلسات الأخرين الكل',
    'admin.security.revokedOthers': '{count, plural, zero {ما فماش جلسات أخرين.} one {تسكّرت جلسة.} two {تسكّرو جلستين.} few {تسكّرو # جلسات.} many {تسكّرو # جلسة.} other {تسكّرو # جلسة.}}',
    'admin.security.recoveryCodes': 'الكودات الاحتياطية',
    'admin.security.recoveryRemaining': '{count, plural, zero {ما بقى حتى كود.} one {بقى كود واحد.} two {بقاو زوز كودات.} few {بقاو # كودات.} many {بقاو # كود.} other {بقاو # كود.}}',
    'admin.security.regenerate': 'اعمل كودات جدد',
    'admin.security.activity': 'آخر النشاط',
    'admin.security.event.sign_in.code_verified': 'كود الدخول تقبل',
    'admin.security.event.sign_in.completed': 'دخلت',
    'admin.security.event.sign_in.mfa_failed': 'التثبّت بخطوتين ما نجحش',
    'admin.security.event.account.created': 'الحساب تعمل',
    'admin.security.event.mfa.totp_enrolled': 'تطبيقة المصادقة تفعّلت',
    'admin.security.event.mfa.recovery_codes_generated': 'كودات احتياطية جدد تعملو',
    'admin.security.event.mfa.recovery_code_used': 'تستعمل كود احتياطي',
    'admin.security.event.session.revoked': 'جلسة تسكّرت',
    'admin.security.event.session.logged_out': 'خرجت',
    'admin.security.mfa.title': 'التحقق المزدوج',
    'admin.security.mfa.on': 'مخدوم: كل دخلة تطلب زادة كود من تطبيقة المصادقة.',
    'admin.security.mfa.off': 'موش مخدوم: تدخل بالكود اللي يجيك في الإيمايل. خدمو باش يتطلب زادة كود من التليفون.',
    'admin.security.mfa.enable': 'خدّم',
    'admin.security.mfa.disable': 'وقّف',
    'admin.security.mfa.codeHint': 'موش لازم في الـ 15 دقيقة اللي بعد دخلة بالتحقق المزدوج.',
    'admin.security.mfa.disabled': 'التحقق المزدوج توقّف.',
    'admin.security.event.mfa.disabled': 'التحقق المزدوج توقّف',
    'admin.audit.title': 'سجل العمليات',
    'admin.audit.date': 'التاريخ',
    'admin.audit.actor': 'شكون عملها',
    'admin.audit.action': 'العملية',
    'admin.audit.target': 'العنصر',
    'admin.audit.ip': 'عنوان IP',
    'admin.audit.empty': 'مازال ما فما حتى عملية.',
    'admin.audit.actor.system': 'السيستام',
    'admin.audit.actor.user': 'مستعمل',
    'admin.audit.actor.api_client': 'تطبيقة',
    // --- module 4: stores, team, invitations ---
    'email.invitation.subject': 'دعوة باش تدخل لـ {store} على {brand}',
    'email.invitation.heading': 'عندك دعوة باش تدخل لـ {store}',
    'email.invitation.intro': '{inviter} يستدعيك باش تدخل لفريق {store} على {brand} بدور «{role}».',
    'email.invitation.action': 'شوف الدعوة',
    'email.invitation.expiry': 'الدعوة هاذي توفى بعد {days, plural, zero {# نهار} one {نهار} two {نهارين} few {# أيام} many {# نهار} other {# نهار}}.',
    'email.invitation.ignore': 'كان ما تعرفش البوتيك هاذي، ما تعمل شي.',
    'admin.error.conflict': 'العملية هاذي تتعارض مع الحالة توا (يمكن تعملت ديجا).',
    'admin.home.createStore': 'اعمل بوتيك',
    'admin.home.openStore': 'حل',
    'admin.store.new.title': 'اعمل البوتيك متاعك',
    'admin.store.new.intro': 'اختار إسم وعنوان. المنتوجات تزيدهم من بعد.',
    'admin.store.nameIn': 'إسم البوتيك ({language})',
    'admin.store.slug': 'عنوان البوتيك',
    'admin.store.slugHint': 'حروف لاتينية صغار، أرقام وتريات. ما تنجمش تبدّلو من بعد.',
    'admin.store.slugAvailable': '{host} موجود.',
    'admin.store.slug.invalid': 'استعمل بين 3 و40 حرف لاتيني صغير، رقم ولا تري وحدو.',
    'admin.store.slug.reserved': 'العنوان هذا محجوز.',
    'admin.store.slug.taken': 'العنوان هذا مستعمل ديجا.',
    'admin.store.defaultLocale': 'اللغة الأساسية متاع البوتيك',
    'admin.store.enabledLocales': 'لغات البوتيك',
    'admin.store.create': 'اعمل البوتيك',
    'admin.store.settings': 'الإعدادات',
    'admin.store.team': 'الفريق',
    'admin.store.addresses': 'العناوين',
    'admin.store.error.defaultLocale': 'اللغة الأساسية لازمها تكون من لغات البوتيك وعندها إسم.',
    'admin.team.members': 'الأعضاء',
    'admin.team.you': 'انت',
    'admin.team.role': 'الدور',
    'admin.team.roleFor': 'دور {name}',
    'admin.team.remove': 'نحّي',
    'admin.team.removeFor': 'نحّي {name}',
    'admin.team.invitations': 'الدعوات اللي تستنى',
    'admin.team.noInvitations': 'ما فما حتى دعوة تستنى.',
    'admin.team.invite': 'استدعي حد',
    'admin.team.inviteLocale': 'لغة الدعوة',
    'admin.team.send': 'ابعث الدعوة',
    'admin.team.sent': 'الدعوة تبعثت.',
    'admin.team.expires': 'توفى نهار {date}',
    'admin.team.cancelInvitation': 'بطّل',
    'admin.invitation.title': 'ادخل لـ {store}',
    'admin.invitation.intro': 'عندك دعوة باش تدخل لـ {store} بدور «{role}».',
    'admin.invitation.accept': 'اقبل الدعوة',
    'admin.invitation.mismatch': 'الدعوة هاذي تبعثت لـ {email}. ادخل بالعنوان هذا باش تقبلها.',
    'admin.invitation.invalid': 'الدعوة هاذي ما عادش صالحة. اطلب وحدة جديدة من مولى البوتيك.',
    'admin.media.title': 'التصاور متاعك',
    'admin.media.upload': 'زيد تصاور',
    'admin.media.uploadHint': 'JPEG ولا PNG ولا WebP ولا AVIF. المعلومات المخبية في التصويرة (البلاصة، التلفون) تتنحى.',
    'admin.media.uploading': 'قاعد نبعث: {done} من {total}…',
    'admin.media.uploaded': '{count, plural, one {تزادت تصويرة.} other {تزادو # تصاور.}}',
    'admin.media.empty': 'ما فما حتى تصويرة توا.',
    'admin.media.dimensions': '{width} × {height} بكسل',
    'admin.media.alt': 'وصف التصويرة ({language})',
    'admin.media.altHint': 'يتقرا للناس اللي ما يشوفوش مليح وتستعملو محركات البحث.',
    'admin.media.edit': 'بدّل',
    'admin.media.editFor': 'بدّل وصف {name}',
    'admin.media.delete': 'فسخ',
    'admin.media.deleteFor': 'فسخ {name}',
    'admin.media.confirmDelete': 'أكّد الفسخ',
    'admin.media.cancel': 'بطّل',
    'admin.media.deleted': 'التصويرة تفسخت.',
    'admin.media.error.payload-too-large': '{name}: الفيشي كبير برشا.',
    'admin.media.error.unsupported-media-type': '{name}: الصيغة هاذي ما تمشيش. استعمل JPEG ولا PNG ولا WebP ولا AVIF.',
    'admin.media.error.invalid-image': '{name}: التصويرة ما تتقراش ولا قياساتها كبار برشا.',
    'admin.media.error.service-unavailable': 'التصاور موش متوفرين توا. عاود بعد شوية.',
    'admin.media.error.file': 'ما نجمناش نبعثو {name}: {message}',
    'admin.catalog.products': 'السلع',
    'admin.catalog.collections': 'المجموعات',
    'admin.catalog.export': 'صدّر (CSV)',
    'admin.catalog.import': 'دخّل فيشي CSV',
    'admin.catalog.importHint': 'سطر لكل نوع. الفيشي يتثبّت قبل: ما يتبدّل شي قبل ما تأكّد.',
    'admin.catalog.importChecking': 'قاعد نثبّت في الفيشي…',
    'admin.catalog.importSummary': '{products, plural, one {سلعة وحدة} other {# سلع}}: {created} باش يتعملو، {updated} باش يتبدّلو.',
    'admin.catalog.importApply': 'دخّل',
    'admin.catalog.importDone': 'كمل الإدخال: {created} تعملو، {updated} تبدّلو.',
    'admin.catalog.importErrors': 'الفيشي فيه غلطات. صلّحهم وعاود.',
    'admin.catalog.importErrorLine': 'السطر {line}: {message}',
    'admin.catalog.importErrorCell': 'السطر {line}، العمود {column}: {message}',
    'admin.catalog.importError.invalid-csv': 'الفيشي موش CSV صحيح.',
    'admin.catalog.importError.no-rows': 'الفيشي ما فيه حتى سلعة.',
    'admin.catalog.importError.unknown-column': 'عمود ما نعرفوهش.',
    'admin.catalog.importError.missing-column': 'عمود لازم ناقص.',
    'admin.catalog.importError.too-many-rows': 'برشا سطور: 10000 سطر أكثر حاجة في الفيشي.',
    'admin.catalog.importError.too-many-products': 'برشا سلع: 2000 سلعة أكثر حاجة في الفيشي.',
    'admin.catalog.importError.required': 'لازم تتعمّر.',
    'admin.catalog.importError.differs': 'موش كيف السطر الأول متاع السلعة هاذي.',
    'admin.catalog.importError.option-numbering': 'الخيارات تتنمرو من 1 بلاش فراغات.',
    'admin.catalog.importError.invalid-amount': 'مبلغ بالدينار بثلاثة أرقام بعد الفاصل أكثر حاجة، كيف 25.500.',
    'admin.catalog.importError.whole-grams': 'الوزن بالغرام بلاش فاصل.',
    'admin.catalog.importError.sku-used': 'الـ SKU هذا متاع سلعة أخرى.',
    'admin.catalog.importError.invalid': 'قيمة موش صحيحة.',
    'admin.product.new': 'سلعة جديدة',
    'admin.product.edit': 'بدّل السلعة',
    'admin.product.search': 'لوّج (الاسم ولا العنوان ولا SKU)',
    'admin.product.statusFilter': 'الحالة',
    'admin.product.allStatuses': 'الكل',
    'admin.product.status.draft': 'مسودة',
    'admin.product.status.active': 'للبيع',
    'admin.product.status.archived': 'في الأرشيف',
    'admin.product.empty': 'ما فما حتى سلعة توا.',
    'admin.product.noMatch': 'ما لقينا حتى سلعة كيف اللي تلوّج عليها.',
    'admin.product.column.product': 'السلعة',
    'admin.product.column.status': 'الحالة',
    'admin.product.column.variants': 'الأنواع',
    'admin.product.column.price': 'السوم',
    'admin.product.column.updated': 'آخر تبديل',
    'admin.product.priceRange': 'من {min} لـ {max}',
    'admin.product.titleIn': 'الاسم ({language})',
    'admin.product.descriptionIn': 'الوصف ({language})',
    'admin.product.handle': 'عنوان الصفحة',
    'admin.product.handleHint': 'حروف لاتينية صغار وأرقام وتيريهات. خلّيه فارغ باش يتعمل من الاسم.',
    'admin.product.tags': 'الوسوم',
    'admin.product.tagsHint': 'بينهم فاصلة.',
    'admin.product.details': 'المعلومات',
    'admin.product.options': 'الخيارات',
    'admin.product.optionsHint': 'كيف القياس ولا اللون. كل تركيبة من القيم ترجع نوع.',
    'admin.product.addOption': 'زيد خيار',
    'admin.product.removeOption': 'نحّي الخيار {number}',
    'admin.product.optionNameIn': 'اسم الخيار {number} ({language})',
    'admin.product.optionValues': 'قيم الخيار {number}',
    'admin.product.valueIn': 'القيمة {index} ({language})',
    'admin.product.addValue': 'زيد قيمة',
    'admin.product.removeValue': 'نحّي القيمة {index}',
    'admin.product.variants': 'السوامات والأنواع',
    'admin.product.variant': 'النوع',
    'admin.product.price': 'السوم (د.ت)',
    'admin.product.priceFor': 'سوم {variant} (د.ت)',
    'admin.product.compareAt': 'السوم قبل التخفيض (د.ت)',
    'admin.product.compareAtFor': 'سوم {variant} قبل التخفيض (د.ت)',
    'admin.product.sku': 'رمز SKU',
    'admin.product.skuFor': 'رمز SKU متاع {variant}',
    'admin.product.barcode': 'الكود بار',
    'admin.product.weight': 'الوزن (غ)',
    'admin.product.tooManyVariants': '{max} نوع أكثر حاجة: نقّص في القيم.',
    'admin.product.images': 'التصاور',
    'admin.product.noImages': 'ما فما حتى تصويرة.',
    'admin.product.addImages': 'اختار من التصاور متاعك',
    'admin.product.closePicker': 'سكّر',
    'admin.product.selectImage': 'اختار {name}',
    'admin.product.moveUp': 'طلّع {name}',
    'admin.product.moveDown': 'هبّط {name}',
    'admin.product.removeImage': 'نحّي {name}',
    'admin.product.save': 'سجّل السلعة',
    'admin.product.saved': 'السلعة تسجلت.',
    'admin.product.delete': 'فسخ السلعة',
    'admin.product.confirmDelete': 'أكّد فسخ السلعة',
    'admin.product.deleted': 'السلعة تفسخت.',
    'admin.product.invalidPrice': 'مبلغ بالدينار بثلاثة أرقام بعد الفاصل أكثر حاجة، كيف 25.500.',
    'admin.product.error.version-conflict': 'السلعة هاذي تبدّلت في الأثناء. عاود حمّل الصفحة وعاود التبديلات متاعك.',
    'admin.product.error.handle-taken': 'العنوان هذا مستعمل.',
    'admin.product.error.sku-taken': 'فما SKU مستعمل في سلعة أخرى.',
    'admin.product.error.validation': 'فما خانات موش صحيحة. ثبّت في الاستمارة.',
    'admin.collection.new': 'مجموعة جديدة',
    'admin.collection.edit': 'بدّل المجموعة',
    'admin.collection.empty': 'ما فما حتى مجموعة توا.',
    'admin.collection.productCount': '{count, plural, one {سلعة وحدة} other {# سلع}}',
    'admin.collection.products': 'سلع المجموعة',
    'admin.collection.noProducts': 'ما فما حتى سلعة في المجموعة هاذي.',
    'admin.collection.findProducts': 'لوّج على سلع باش تزيدها',
    'admin.collection.addProduct': 'زيد {name}',
    'admin.collection.removeProduct': 'نحّي {name}',
    'admin.collection.status.draft': 'مسودة',
    'admin.collection.status.active': 'ظاهرة',
    'admin.collection.save': 'سجّل المجموعة',
    'admin.collection.saved': 'المجموعة تسجلت.',
    'admin.collection.delete': 'فسخ المجموعة',
    'admin.collection.confirmDelete': 'أكّد فسخ المجموعة',
    'admin.collection.deleted': 'المجموعة تفسخت.',
    'admin.catalog.csv': 'الإدخال والتصدير',
    'admin.inventory.title': 'السطوك',
    'admin.inventory.search': 'لوّج (الاسم ولا SKU)',
    'admin.inventory.filter': 'ورّي',
    'admin.inventory.filter.all': 'الكل',
    'admin.inventory.filter.tracked': 'السطوك المتّبع',
    'admin.inventory.filter.out-of-stock': 'كمل من السطوك',
    'admin.inventory.empty': 'ما فما شي.',
    'admin.inventory.column.item': 'السلعة',
    'admin.inventory.column.onHand': 'في السطوك',
    'admin.inventory.column.reserved': 'محجوز',
    'admin.inventory.column.available': 'موجود',
    'admin.inventory.column.state': 'الحالة',
    'admin.inventory.state.untracked': 'موش متّبع (بيع بلاش حد)',
    'admin.inventory.state.backorder': 'يتباع حتى كي يكمل',
    'admin.inventory.state.out': 'كمل من السطوك',
    'admin.inventory.state.in': 'موجود',
    'admin.inventory.manage': 'تصرّف في سطوك {name}',
    'admin.inventory.settings': 'تتبّع السطوك',
    'admin.inventory.track': 'تتبّع السطوك متاع السلعة هاذي',
    'admin.inventory.allowBackorder': 'كمّل بيع حتى كي يكمل السطوك',
    'admin.inventory.saveSettings': 'سجّل الإعدادات',
    'admin.inventory.settingsSaved': 'الإعدادات تسجلت.',
    'admin.inventory.adjust': 'صلّح السطوك',
    'admin.inventory.reason': 'السبب',
    'admin.inventory.reason.received': 'وصلت سلعة',
    'admin.inventory.reason.returned': 'رجّعها حريف',
    'admin.inventory.reason.damaged': 'تكسّرت ولا ضاعت',
    'admin.inventory.reason.correction': 'تصليح',
    'admin.inventory.reason.count': 'جرد',
    'admin.inventory.reason.reserved': 'محجوزة',
    'admin.inventory.reason.released': 'تفسخ الحجز',
    'admin.inventory.reason.expired': 'الحجز وفى وقتو',
    'admin.inventory.reason.committed': 'تباعت',
    'admin.inventory.reason.tracking': 'إعدادات التتبّع',
    'admin.inventory.quantity': 'الكمية',
    'admin.inventory.quantityHint': 'قدّاش من حبّة زدت ولا نحّيت.',
    'admin.inventory.correctionHint': 'العدد بالناقص ينحّي من السطوك.',
    'admin.inventory.note': 'ملاحظة (كان تحب)',
    'admin.inventory.apply': 'سجّل التصليح',
    'admin.inventory.count': 'جرد بالعين',
    'admin.inventory.counted': 'الكمية اللي عدّيتها',
    'admin.inventory.saveCount': 'سجّل الجرد',
    'admin.inventory.saved': 'السطوك تبدّل.',
    'admin.inventory.history': 'التاريخ',
    'admin.inventory.noHistory': 'ما فما حتى حركة توا.',
    'admin.inventory.column.date': 'النهار',
    'admin.inventory.column.change': 'التبديل',
    'admin.inventory.column.after': 'السطوك من بعد',
    'admin.inventory.column.note': 'ملاحظة',
    'admin.inventory.error.stock-conflict': 'السطوك ما ينجمش يهبط تحت الصفر ولا تحت اللي محجوز.',
    'admin.inventory.error.quantity': 'اكتب عدد صحيح.',
    'storefront.skipToContent': 'امشي للمحتوى',
    'storefront.menu': 'القائمة',
    'storefront.language': 'اللغة',
    'storefront.search': 'لوّج',
    'storefront.searchLabel': 'لوّج على سلعة',
    'storefront.searchTitle': 'التلويج',
    'storefront.results': '{count, plural, one {نتيجة وحدة} other {# نتائج}} على «{query}»',
    'storefront.noResults': 'ما لقينا حتى سلعة كيف اللي تلوّج عليها.',
    'storefront.searchUnavailable': 'التلويج موش خدّام توا. عاود بعد شوية.',
    'storefront.sort': 'رتّب حسب',
    'storefront.sort.relevance': 'الأقرب',
    'storefront.sort.price-asc': 'السوم من الرخيص للغالي',
    'storefront.sort.price-desc': 'السوم من الغالي للرخيص',
    'storefront.sort.newest': 'الجديد',
    'storefront.apply': 'طبّق',
    'storefront.previous': 'الصفحة اللي قبل',
    'storefront.next': 'الصفحة اللي بعد',
    'storefront.available': 'موجود',
    'storefront.soldOut': 'كمل',
    'storefront.from': 'من {price}',
    'storefront.oldPrice': 'السوم القديم: {price}',
    'storefront.viewAll': 'شوف الكل',
    'storefront.emptyCollection': 'ما فما حتى سلعة توا.',
    'storefront.productImages': 'تصاور {title}',
    'storefront.noCombination': 'التركيبة هاذي موش موجودة.',
    'storefront.preview': 'معاينة: النسخة هاذي متاع البوتيك مازالت ما تنشرتش.',
    'storefront.notFound': 'الصفحة موش موجودة',
    'storefront.notFoundText': 'الصفحة اللي تلوّج عليها موش موجودة ولا ما عادش موجودة.',
    'storefront.backHome': 'ارجع للصفحة الرئيسية',
    'storefront.storeNotFound': 'البوتيك هاذي موش موجودة.',
    'storefront.storeUnavailable': 'البوتيك هاذي مسكّرة شوية.',
    'storefront.error': 'صار مشكل.',
    'storefront.retry': 'عاود',
    'storefront.poweredBy': 'بوتيك معمولة بـ {brand}',
    'admin.theme.title': 'شكل البوتيك',
    'admin.theme.colors': 'الألوان والهوية',
    'admin.theme.color.background': 'الفون',
    'admin.theme.color.text': 'الكتيبة',
    'admin.theme.color.accent': 'البوطونات والروابط',
    'admin.theme.color.accentText': 'كتيبة البوطونات',
    'admin.theme.contrastLow': 'التباين ضعيف ({ratio}:1، لازم 4.5:1 أقل حاجة): الكتيبة باش تتقرا بالسيف.',
    'admin.theme.logo': 'اللوغو',
    'admin.theme.noImage': 'بلاش تصويرة',
    'admin.theme.announcementIn': 'بندو الإعلان ({language})',
    'admin.theme.navigation': 'القائمة',
    'admin.theme.addNavItem': 'زيد رابط للقائمة',
    'admin.theme.navLabelIn': 'اسم الرابط {number} ({language})',
    'admin.theme.linkFor': 'وين يهز الرابط {number}',
    'admin.theme.removeNav': 'نحّي الرابط {number}',
    'admin.theme.link.none': 'حتى شي',
    'admin.theme.link.home': 'الصفحة الرئيسية',
    'admin.theme.link.search': 'التلويج',
    'admin.theme.link.collection': 'مجموعة: {name}',
    'admin.theme.link.product': 'سلعة: {name}',
    'admin.theme.sections': 'الصفحة الرئيسية',
    'admin.theme.sectionType': 'نوع القسم',
    'admin.theme.addSection': 'زيد القسم',
    'admin.theme.section.hero': 'بانو',
    'admin.theme.section.featured-collection': 'مجموعة مبرزة',
    'admin.theme.section.product-grid': 'آخر السلع',
    'admin.theme.section.rich-text': 'كتيبة',
    'admin.theme.section.image-with-text': 'تصويرة وكتيبة',
    'admin.theme.sectionN': 'القسم {number}: {type}',
    'admin.theme.headingIn': 'العنوان ({language})',
    'admin.theme.textIn': 'الكتيبة ({language})',
    'admin.theme.buttonLabelIn': 'كتيبة البوطون ({language})',
    'admin.theme.buttonLink': 'وين يهز البوطون',
    'admin.theme.image': 'التصويرة',
    'admin.theme.imagePosition': 'بلاصة التصويرة',
    'admin.theme.imagePosition.start': 'قبل الكتيبة',
    'admin.theme.imagePosition.end': 'بعد الكتيبة',
    'admin.theme.collection': 'المجموعة',
    'admin.theme.limit': 'قدّاش من سلعة',
    'admin.theme.moveUp': 'طلّع القسم {number}',
    'admin.theme.moveDown': 'هبّط القسم {number}',
    'admin.theme.remove': 'نحّي القسم {number}',
    'admin.theme.save': 'سجّل المسودة',
    'admin.theme.saved': 'المسودة تسجلت.',
    'admin.theme.preview': 'شوف قبل',
    'admin.theme.openPreview': 'حلّ المعاينة',
    'admin.theme.previewHint': 'رابط المعاينة يمشي ساعة.',
    'admin.theme.publish': 'انشر',
    'admin.theme.published': 'تنشر: الحرفاء متاعك يشوفو توا النسخة هاذي.',
    'admin.theme.unpublished': 'فما تبديلات مازالت ما تنشرتش.',
    'admin.theme.upToDate': 'البوتيك توري آخر نسخة منشورة.',
    'admin.theme.history': 'النسخ المنشورة',
    'admin.theme.noHistory': 'مازال ما تنشر شي.',
    'admin.theme.version': 'النسخة {number}',
    'admin.theme.current': 'منشورة',
    'admin.theme.restore': 'رجّع النسخة {number}',
    'admin.theme.restored': 'النسخة رجعت للمسودة. انشرها باش تبان للحرفاء.',
    'admin.theme.error.version-conflict': 'الشكل تبدّل في الأثناء. عاود حمّل الصفحة.',
    'admin.theme.template': 'القالب',
    'admin.theme.template.souk': 'السوق',
    'admin.theme.template.atelier': 'الورشة',
    'admin.theme.template.ledger': 'الدفتر',
    'admin.theme.template.hint': 'كي تختار قالب، الألوان والصفحة الرئيسية في المسودة يتبدلوا. الشعار والقائمة والصفحات يبقاو. الحرفاء يشوفوه بعد ما تنشر.',
    'admin.theme.template.apply': 'طبّق {name}',
    'admin.theme.template.confirm': 'تبدّل ألوان المسودة والصفحة الرئيسية بالقالب هذا؟ الموقع المنشور ما يتبدل كان كي تنشر.',
    'admin.theme.template.applied': 'القالب تطبق على المسودة. انشرو باش يبان للحرفاء.',
    'admin.theme.link.page': 'صفحة: {name}',
    'admin.theme.pages': 'الصفحات',
    'admin.theme.addPage': 'زيد صفحة',
    'admin.theme.pageHandle': 'عنوان الصفحة {number}',
    'admin.theme.pageTitleIn': 'عنوان الصفحة {number} ({language})',
    'admin.theme.removePage': 'احذف الصفحة {number}',
    'admin.theme.pageSectionType': 'نوع قسم الصفحة {number}',
    'admin.theme.addPageSection': 'زيد قسم للصفحة {number}',
    'admin.theme.slots.product': 'صفحة المنتج',
    'admin.theme.slots.collection': 'صفحة المجموعة',
    'admin.theme.slots.cart': 'السلة',
    'admin.theme.slots.before': 'قبل المحتوى',
    'admin.theme.slots.after': 'بعد المحتوى',
    'admin.theme.slotSectionType': 'نوع القسم ({place})',
    'admin.theme.addSlotSection': 'زيد قسم ({place})',
    'admin.theme.place.product.before': 'قبل المنتج',
    'admin.theme.place.product.after': 'بعد المنتج',
    'admin.theme.place.collection.before': 'قبل المجموعة',
    'admin.theme.place.collection.after': 'بعد المجموعة',
    'admin.theme.place.cart.before': 'قبل السلة',
    'admin.theme.place.cart.after': 'بعد السلة',
    'admin.theme.reservedHandle': 'العنوان هذا مستعمل في الحانوت (السلة، الخلاص، البحث…).',
    'admin.theme.duplicateHandle': 'صفحتين ما ينجموش بنفس العنوان.',
    // --- module 10: checkout settings, discount codes, orders ---
    'admin.checkout.title': 'الخلاص والتوصيل',
    'admin.checkout.unavailable': 'البوتيك مازالت ما تاخوش كوموندات: فعّل على الأقل طريقة خلاص وحدة وطريقة توصيل وحدة.',
    'admin.checkout.available': 'البوتيك تاخو في الكوموندات.',
    'admin.checkout.saved': 'الإعدادات تسجلو.',
    'admin.checkout.error.validation': 'ثبّت في الخانات المعلّمة.',
    'admin.checkout.error.version-conflict': 'الإعدادات تبدلو في الأثناء. عاود حمّل الصفحة.',
    'admin.checkout.payments': 'طرق الخلاص',
    'admin.checkout.cashOnDelivery': 'الخلاص كي توصل السلعة',
    'admin.checkout.bankTransfer': 'فيرمون بنكي (إنت تأكد الوصول)',
    'admin.checkout.bankInstructionsIn': 'تعليمات الفيرمون ({language})',
    'admin.checkout.bankInstructionsHint': 'الريب ومولى الحساب: يظهرو للحريف وفي إيمايل التأكيد.',
    'admin.checkout.delivery': 'التوصيل',
    'admin.checkout.shippingEnabled': 'التوصيل للدار',
    'admin.checkout.zone': 'المنطقة {number}',
    'admin.checkout.zoneNameIn': 'اسم المنطقة ({language})',
    'admin.checkout.zonePrice': 'معلوم التوصيل (د.ت)',
    'admin.checkout.zoneFreeOver': 'التوصيل بلاش من (د.ت، اختياري)',
    'admin.checkout.zoneGovernorates': 'الولايات اللي نوصلولها',
    'admin.checkout.addZone': 'زيد منطقة',
    'admin.checkout.removeZone': 'نحّي المنطقة {number}',
    'admin.checkout.pickupEnabled': 'تهزها من البوتيك',
    'admin.checkout.pickupAddressIn': 'عنوان البوتيك ({language})',
    'admin.checkout.taxes': 'الأداءات',
    'admin.checkout.taxesEnabled': 'نحسبو التي في آ (مؤسسة خاضعة)',
    'admin.checkout.taxesHint': 'النسب متاعك: ثبّتهم مع الكونتابل متاعك. beinstore ما يحط حتى نسبة وحدو.',
    'admin.checkout.pricesIncludeTax': 'أسوام البوتيك',
    'admin.checkout.pricesIncludeTax.yes': 'فيهم الأداء',
    'admin.checkout.pricesIncludeTax.no': 'من غير أداء (يتزاد في الخلاص)',
    'admin.checkout.fiscalId': 'الماتريكول الفيسكال',
    'admin.checkout.taxClass': 'النسبة {number}',
    'admin.checkout.taxClassKey': 'الكود (تستعملو السلع وملف CSV)',
    'admin.checkout.taxClassNameIn': 'الاسم ({language})',
    'admin.checkout.taxClassRate': 'النسبة (%)',
    'admin.checkout.addTaxClass': 'زيد نسبة',
    'admin.checkout.removeTaxClass': 'نحّي النسبة {number}',
    'admin.checkout.defaultClass': 'نسبة السلع اللي ما عندهاش نسبة',
    'admin.checkout.shippingClass': 'النسبة على التوصيل',
    'admin.checkout.noClass': 'حتى شي (من غير أداء)',
    'admin.checkout.fee': 'معلوم ثابت على كل كوموند',
    'admin.checkout.feeAmount': 'المبلغ (د.ت، فارغ = حتى شي)',
    'admin.checkout.feeLabelIn': 'التسمية ({language})',
    'admin.checkout.feeHint': 'كيف التمبر الفيسكال، كان تستعملو.',
    'admin.checkout.invalidAmount': 'المبلغ موش صحيح.',
    'admin.checkout.invalidRate': 'النسبة موش صحيحة (من 0 لـ 100، زوز أرقام بعد الفاصل على الأكثر).',
    'admin.checkout.invalidKey': 'حروف لاتينية صغار وأرقام وتيريات.',
    'admin.discount.title': 'كودات الريميز',
    'admin.discount.new': 'كود جديد',
    'admin.discount.empty': 'مازال ما فماش كودات ريميز.',
    'admin.discount.column.code': 'الكود',
    'admin.discount.column.value': 'الريميز',
    'admin.discount.column.used': 'قدّاش تستعمل',
    'admin.discount.column.status': 'الحالة',
    'admin.discount.column.validity': 'الصلوحية',
    'admin.discount.kind': 'نوع الريميز',
    'admin.discount.kind.percentage': 'بالمية',
    'admin.discount.kind.fixed_amount': 'مبلغ ثابت',
    'admin.discount.kind.free_shipping': 'التوصيل بلاش',
    'admin.discount.value.percentage': 'ريميز {percent}٪',
    'admin.discount.code': 'الكود',
    'admin.discount.codeHint': 'حروف وأرقام و - و _ (من 3 لـ 40). الحريف ينجم يكتبو بالصغير.',
    'admin.discount.percent': 'النسبة (%)',
    'admin.discount.amount': 'المبلغ (د.ت)',
    'admin.discount.minSubtotal': 'أقل مبلغ للسلة (د.ت، اختياري)',
    'admin.discount.startsOn': 'صالح من (اختياري)',
    'admin.discount.endsOn': 'صالح حتى لـ (محسوب، اختياري)',
    'admin.discount.datesHint': 'التواريخ بوقت تونس.',
    'admin.discount.usageLimit': 'قدّاش من مرة يتستعمل في الكل (اختياري)',
    'admin.discount.perCustomerLimit': 'قدّاش من مرة لكل حريف (اختياري)',
    'admin.discount.perCustomerHint': 'الحريف نعرفوه بنومرو التليفون متاعو.',
    'admin.discount.status': 'الحالة',
    'admin.discount.status.active': 'خدّام',
    'admin.discount.status.disabled': 'مسكّر',
    'admin.discount.always': 'من غير حد في الوقت',
    'admin.discount.from': 'من {date}',
    'admin.discount.until': 'حتى لـ {date}',
    'admin.discount.between': 'من {start} لـ {end}',
    'admin.discount.edit': 'بدّل الكود',
    'admin.discount.saved': 'الكود تسجل.',
    'admin.discount.error.conflict': 'الكود هذا موجود.',
    'admin.discount.error.version-conflict': 'الكود تبدل في الأثناء. عاود حمّل الصفحة.',
    'admin.discount.error.validation': 'ثبّت في الخانات المعلّمة.',
    'admin.discount.invalidPercent': 'بين 0.01 و 100.',
    'admin.discount.invalidNumber': 'عدد صحيح موجب.',
    'admin.discount.invalidDates': 'النهاية لازمها تكون بعد البداية.',
    'admin.order.title': 'الكوموندات',
    'admin.order.search': 'لوّج (الاسم، التليفون ولا النومرو)',
    'admin.order.empty': 'مازال ما فماش كوموندات.',
    'admin.order.column.number': 'النومرو',
    'admin.order.column.date': 'التاريخ',
    'admin.order.column.customer': 'الحريف',
    'admin.order.column.total': 'المجموع',
    'admin.order.column.payment': 'الخلاص',
    'admin.order.column.delivery': 'التوصيل',
    'admin.order.number': 'الكوموند نومرو {number}',
    'admin.order.open': 'حل الكوموند نومرو {number}',
    'admin.order.payment.cash_on_delivery': 'كي توصل',
    'admin.order.payment.bank_transfer': 'فيرمون بنكي',
    'admin.order.paymentStatus': 'حالة الخلاص',
    'admin.order.paymentStatus.pending': 'نستناو',
    'admin.order.paymentStatus.paid': 'مخلّصة',
    'admin.order.delivery.shipping': 'التوصيل للدار',
    'admin.order.delivery.pickup': 'تهزها من البوتيك',
    'admin.order.placedAt': 'نهار {date}',
    'admin.order.customer': 'الحريف',
    'admin.order.phone': 'التليفون',
    'admin.order.email': 'الإيمايل',
    'admin.order.address': 'عنوان التوصيل',
    'admin.order.note': 'ملاحظة الحريف',
    'admin.order.items': 'السلع',
    'admin.order.column.item': 'السلعة',
    'admin.order.column.unitPrice': 'سوم الوحدة',
    'admin.order.column.quantity': 'العدد',
    'admin.order.subtotal': 'المجموع الفرعي',
    'admin.order.discount': 'الريميز ({code})',
    'admin.order.shipping': 'التوصيل',
    'admin.order.tax': 'التي في آ',
    'admin.order.taxIncluded': 'منها الأداء',
    'admin.order.taxLine': 'أداء {rate}٪ على {net}: {tax}',
    'admin.order.fee': 'معلوم ({label})',
    'admin.order.total': 'المجموع',
    'admin.order.instructions': 'التعليمات اللي تبعثت للحريف',
    'admin.order.fiscalNote': 'المبالغ تسجلو وقت الكوموند وما عادش يتبدلو.',
    'admin.product.taxClass': 'نسبة الأداء',
    'admin.product.taxClass.default': 'النسبة متاع البوتيك',
    'admin.product.taxClass.unknown': '{key} (موش موجودة في الإعدادات: تتحسب النسبة العادية)',
    // --- module 10: storefront cart and checkout ---
    'storefront.cart': 'الباني',
    'storefront.cartWithCount': 'الباني ({count, plural, =0 {فارغ} one {سلعة وحدة} other {# سلع}})',
    'storefront.cart.title': 'الباني متاعك',
    'storefront.cart.empty': 'الباني متاعك فارغ.',
    'storefront.cart.continue': 'كمّل اشري',
    'storefront.cart.product': 'السلعة',
    'storefront.cart.price': 'السوم',
    'storefront.cart.quantity': 'العدد',
    'storefront.cart.quantityOf': 'العدد متاع {title}',
    'storefront.cart.lineTotal': 'المجموع',
    'storefront.cart.update': 'بدّل',
    'storefront.cart.remove': 'نحّي',
    'storefront.cart.removeItem': 'نحّي {title} من الباني',
    'storefront.cart.unavailable': 'ما عادش موجودة: نحّيها باش تكمّل الكوموند.',
    'storefront.cart.subtotal': 'المجموع الفرعي',
    'storefront.cart.discount': 'الريميز ({code})',
    'storefront.cart.shipping': 'التوصيل',
    'storefront.cart.shippingLater': 'تتحسب في المرحلة الجاية',
    'storefront.cart.free': 'بلاش',
    'storefront.cart.tax': 'التي في آ',
    'storefront.cart.taxIncluded': 'منها الأداء',
    'storefront.cart.fee': 'معلوم',
    'storefront.cart.total': 'المجموع',
    'storefront.cart.checkout': 'كمّل الكوموند',
    'storefront.cart.checkoutUnavailable': 'البوتيك هاذي مازالت ما تاخوش كوموندات أونلاين.',
    'storefront.cart.add': 'زيد للباني',
    'storefront.cart.error.sold-out': 'السلعة هذي وفات.',
    'storefront.cart.error.full': 'الباني متاعك معبّي.',
    'storefront.cart.error.unavailable': 'السلعة هذي ما عادش موجودة.',
    'storefront.cart.error.too-many': 'برشا محاولات. عاود بعد شوية دقايق.',
    'storefront.cart.error.generic': 'صار مشكل. عاود جرّب.',
    'storefront.discount.label': 'كود الريميز',
    'storefront.discount.apply': 'طبّق',
    'storefront.discount.remove': 'نحّي الكود',
    'storefront.discount.applied': 'كود الريميز تطبّق.',
    'storefront.discount.refusal.unknown': 'الكود هذا موش موجود.',
    'storefront.discount.refusal.inactive': 'الكود هذا ما عادش خدّام.',
    'storefront.discount.refusal.not-started': 'الكود هذا مازال ما بداش.',
    'storefront.discount.refusal.expired': 'الكود هذا وفى.',
    'storefront.discount.refusal.minimum': 'مبلغ الباني ما يكفيش للكود هذا.',
    'storefront.discount.refusal.exhausted': 'الكود هذا وصل للحد متاعو.',
    'storefront.discount.refusal.customer-limit': 'إنت ديجا استعملت الكود هذا.',
    'storefront.discount.refusal.too-many': 'برشا محاولات. عاود من بعد.',
    'storefront.discount.refusal.error': 'ما نجمناش نثبتو في الكود. عاود جرّب.',
    'storefront.checkout.title': 'الكوموند',
    'storefront.checkout.backToCart': 'ارجع للباني',
    'storefront.checkout.deliveryChoice': 'كيفاش توصلك',
    'storefront.checkout.pickup': 'تهزها من البوتيك',
    'storefront.checkout.pickupAt': 'تهزها من البوتيك: {address}',
    'storefront.checkout.shippingTo': 'التوصيل للدار',
    'storefront.checkout.governorate': 'الولاية',
    'storefront.checkout.choose': 'اختار…',
    'storefront.checkout.governoratePrice': '{name} — {price} للتوصيل',
    'storefront.checkout.governoratePriceFree': '{name} — {price}، بلاش من {amount}',
    'storefront.checkout.continue': 'كمّل',
    'storefront.checkout.change': 'بدّل التوصيل',
    'storefront.checkout.notServed': 'البوتيك ما توصلش للولاية هذي.',
    'storefront.checkout.contact': 'المعلومات متاعك',
    'storefront.checkout.name': 'الاسم واللقب',
    'storefront.checkout.phone': 'التليفون',
    'storefront.checkout.phoneHint': 'نومرو تونسي بـ 8 أرقام، ولا دولي بـ +',
    'storefront.checkout.email': 'الإيمايل (اختياري، باش يوصلك التأكيد)',
    'storefront.checkout.address': 'عنوان التوصيل',
    'storefront.checkout.city': 'المدينة',
    'storefront.checkout.line1': 'العنوان (النهج، النومرو)',
    'storefront.checkout.line2': 'تكملة العنوان (اختياري)',
    'storefront.checkout.postalCode': 'الكود البوستال (اختياري)',
    'storefront.checkout.payment': 'الخلاص',
    'storefront.checkout.cashOnDelivery': 'الخلاص كي توصلك',
    'storefront.checkout.bankTransfer': 'فيرمون بنكي',
    'storefront.checkout.note': 'ملاحظة للبوتيك (اختياري)',
    'storefront.checkout.place': 'أكّد الكوموند ({total})',
    'storefront.checkout.summary': 'الملخص',
    'storefront.checkout.field.required': 'الخانة هذي لازمة.',
    'storefront.checkout.field.phone': 'نومرو التليفون موش صحيح.',
    'storefront.checkout.field.email': 'الإيمايل موش صحيح.',
    'storefront.checkout.field.postalCode': 'أربعة أرقام.',
    'storefront.checkout.field.invalid': 'القيمة موش صحيحة.',
    'storefront.checkout.error.validation': 'ثبّت في المعلومات اللي كتبتها.',
    'storefront.checkout.error.cart-changed': 'شوية سلع ما عادش موجودين. ثبّت في الباني متاعك.',
    'storefront.checkout.error.discount-invalid': 'كود الريميز ما عادش يتستعمل. نحّيه من الباني.',
    'storefront.checkout.error.checkout-unavailable': 'البوتيك ما عادش تعرض الاختيار هذا.',
    'storefront.checkout.error.insufficient-stock': 'سلعة ما عادش موجودة بالعدد هذا.',
    'storefront.checkout.error.too-many-requests': 'برشا محاولات. عاود بعد شوية دقايق.',
    'storefront.checkout.error.generic': 'الكوموند ما تعدّاتش. عاود جرّب.',
    'storefront.order.title': 'يعيشك على الكوموند!',
    'storefront.order.number': 'الكوموند نومرو {number}',
    'storefront.order.cashOnDelivery': 'باش تخلّص كي توصلك: حضّر {total}.',
    'storefront.order.bankTransfer': 'اعمل فيرمون بـ {total}:',
    'storefront.order.pickup': 'تهزها من البوتيك: البوتيك باش تكلمك كي تكون الكوموند حاضرة.',
    'storefront.order.shippingTo': 'التوصيل لـ:',
    'storefront.order.contact': 'البوتيك باش تكلمك على {phone}.',
    'storefront.order.keep': 'خبّي عنوان الصفحة هذي: تنجم تشوف بيه الكوموند متاعك.',
    'storefront.order.view': 'شوف الكوموند متاعي',
    'storefront.order.notFound': 'الكوموند موش موجودة.',
    // --- module 11: order management, invoices ---
    'email.orderStatus.confirmed.subject': '{store} أكّد الكوموند نومرو {number}',
    'email.orderStatus.confirmed.heading': 'الكوموند متاعك تأكدت',
    'email.orderStatus.confirmed.intro': '{store} أكّد الكوموند متاعك نومرو {number} وقاعد يحضّر فيها.',
    'email.orderStatus.shipped.subject': 'الكوموند نومرو {number} تبعثت – {store}',
    'email.orderStatus.shipped.heading': 'الكوموند متاعك في الثنية',
    'email.orderStatus.shipped.intro': '{store} بعث الكوموند متاعك نومرو {number}.',
    'email.orderStatus.delivered.subject': 'الكوموند نومرو {number} وصلت – {store}',
    'email.orderStatus.delivered.heading': 'الكوموند متاعك وصلت',
    'email.orderStatus.delivered.intro': 'الكوموند متاعك نومرو {number} من {store} وصلت. يعيشك!',
    'email.orderStatus.cancelled.subject': 'الكوموند نومرو {number} تبطلت – {store}',
    'email.orderStatus.cancelled.heading': 'الكوموند متاعك تبطلت',
    'email.orderStatus.cancelled.intro': '{store} بطّل الكوموند متاعك نومرو {number}. كلّم البوتيك كان عندك سؤال.',
    'email.orderStatus.tracking': 'التتبع: {note}',
    'invoice.title': 'فاتورة',
    'invoice.number': 'نومرو {number}',
    'invoice.date': 'التاريخ: {date}',
    'invoice.order': 'الكوموند نومرو {number} نهار {date}',
    'invoice.taxId': 'الماتريكول الفيسكال: {taxId}',
    'invoice.billTo': 'الحريف',
    'invoice.payment': 'الخلاص والتوصيل',
    'invoice.paymentMethod.cash_on_delivery': 'الخلاص كي توصل',
    'invoice.paymentMethod.bank_transfer': 'فيرمون بنكي',
    'invoice.delivery.shipping': 'التوصيل للدار',
    'invoice.delivery.pickup': 'تهزها من البوتيك',
    'invoice.column.item': 'السلعة',
    'invoice.column.quantity': 'العدد',
    'invoice.column.unitPrice': 'سوم الوحدة',
    'invoice.column.discount': 'الريميز',
    'invoice.column.total': 'المبلغ',
    'invoice.subtotal': 'المجموع الفرعي',
    'invoice.discount': 'الريميز',
    'invoice.discountCode': 'الريميز ({code})',
    'invoice.shipping': 'التوصيل',
    'invoice.fee': 'معلوم',
    'invoice.tax': 'التي في آ',
    'invoice.taxIncluded': 'منها الأداء',
    'invoice.taxLine': 'أداء {rate}٪ على {net}: {tax}',
    'invoice.total': 'المجموع',
    'admin.inventory.reason.cancelled': 'كوموند تبطلت',
    'admin.order.status': 'الحالة',
    'admin.order.status.placed': 'جديدة',
    'admin.order.status.confirmed': 'متأكدة',
    'admin.order.status.shipped': 'تبعثت',
    'admin.order.status.delivered': 'وصلت',
    'admin.order.status.cancelled': 'تبطلت',
    'admin.order.status.returned': 'ترجعت',
    'admin.order.paymentStatus.refunded': 'ترجّعت الفلوس',
    'admin.order.filter.allStatuses': 'الحالات الكل',
    'admin.order.filter.allPayments': 'الخلاص الكل',
    'admin.order.actions': 'الإجراءات',
    'admin.order.noActions': 'ما فماش حتى إجراء: الكوموند كملت.',
    'admin.order.action.confirm': 'أكّد الكوموند',
    'admin.order.action.ship': 'علّم إنها تبعثت',
    'admin.order.action.deliver': 'علّم إنها وصلت',
    'admin.order.action.cancel': 'بطّل الكوموند',
    'admin.order.action.return': 'سجّل رجوع',
    'admin.order.action.mark-paid': 'علّم إنها تخلّصت',
    'admin.order.action.refund': 'علّم إن الفلوس ترجعت',
    'admin.order.trackingNote': 'التتبع للحريف (اختياري)',
    'admin.order.trackingNoteHint': 'شركة التوصيل، نومرو التتبع… يتبعث للحريف بالإيمايل.',
    'admin.order.actionNote': 'ملاحظة داخلية (اختياري)',
    'admin.order.cancelHint': 'السلع المتبّعة في الستوك ترجع للبيع.',
    'admin.order.returnHint': 'قول شنوّة يرجع للستوك؛ السلع المكسّرة تقعد برّا.',
    'admin.order.restockOf': 'يرجع للستوك: {title}',
    'admin.order.apply': 'أكّد',
    'admin.order.updated': 'الكوموند تبدلت.',
    'admin.order.error.invalid-transition': 'التبديل هذا ما عادش ممكن. عاود حمّل الصفحة.',
    'admin.order.error.version-conflict': 'الكوموند تبدلت في الأثناء. عاود حمّل الصفحة.',
    'admin.order.error.invoice-settings-missing': 'دخّل قبل الاسم القانوني والعنوان في إعدادات الفاتورة.',
    'admin.order.error.invoice-exists': 'الفاتورة موجودة.',
    'admin.order.tracking': 'التتبع: {note}',
    'admin.order.history': 'التاريخ',
    'admin.order.history.placed': 'الكوموند تعدّات',
    'admin.order.history.status': 'الحالة: {from} ← {to}',
    'admin.order.history.payment': 'الخلاص: {from} ← {to}',
    'admin.order.history.note': 'ملاحظة',
    'admin.order.history.invoice': 'الفاتورة {number} خرجت',
    'admin.order.history.restocked': '{count, plural, one {سلعة وحدة رجعت للستوك} other {# سلع رجعو للستوك}}',
    'admin.order.noteLabel': 'ملاحظة داخلية',
    'admin.order.addNote': 'زيد الملاحظة',
    'admin.order.noteAdded': 'الملاحظة تزادت.',
    'admin.order.invoice': 'الفاتورة',
    'admin.order.invoiceNone': 'ما خرجت حتى فاتورة.',
    'admin.order.invoiceLanguage': 'لغة الفاتورة',
    'admin.order.issueInvoice': 'خرّج الفاتورة',
    'admin.order.invoiceIssued': 'الفاتورة خرجت.',
    'admin.order.downloadInvoice': 'نزّل الفاتورة {number} (PDF)',
    'admin.invoice.title': 'الفاتورة',
    'admin.invoice.intro': 'المعلومات هذي تتطبع كيف ما هي على الفواتير متاعك. إنت المسؤول على صحتها وعلى البيانات الإجبارية؛ beinstore ما يزيد حتى صيغة قانونية.',
    'admin.invoice.legalNameIn': 'الاسم القانوني ({language})',
    'admin.invoice.addressIn': 'العنوان ({language})',
    'admin.invoice.taxId': 'الماتريكول الفيسكال (اختياري)',
    'admin.invoice.footerIn': 'نص تحت الصفحة ({language}، اختياري)',
    'admin.invoice.prefix': 'بداية النومروات (اختياري)',
    'admin.invoice.prefixHint': 'حروف وأرقام و / و - (12 على الأكثر)، كيف FA-. النومروات تتبع بعضها من غير فراغ.',
    'admin.invoice.invalidPrefix': 'البداية موش صحيحة.',
    'admin.invoice.saved': 'إعدادات الفاتورة تسجلو.',
    'admin.invoice.error.validation': 'ثبّت في الخانات المعلّمة.',
    'admin.invoice.error.version-conflict': 'الإعدادات تبدلو في الأثناء. عاود حمّل الصفحة.',
    'storefront.order.status': 'الحالة: {status}',
    'storefront.order.status.placed': 'وصلت، تستنى في التأكيد',
    'storefront.order.status.confirmed': 'متأكدة، قاعدين نحضرو فيها',
    'storefront.order.status.shipped': 'تبعثت',
    'storefront.order.status.delivered': 'وصلت',
    'storefront.order.status.cancelled': 'تبطلت',
    'storefront.order.status.returned': 'ترجعت',
    'storefront.order.tracking': 'التتبع: {note}',
    // --- module 16: private apps and webhooks ---
    'admin.integrations.title': 'التطبيقات والويبهوك',
    'admin.integrations.intro': 'اربط الأدوات متاعك (ERP، الكاسة، Excel) بالبوتيك متاعك.',
    'admin.integrations.apps': 'التطبيقات الخاصة',
    'admin.integrations.appsIntro': 'كل تطبيق ياخو كود سري محدود بالصلاحيات اللي تختارها. ما تعطيه كان لشخص تثق فيه.',
    'admin.integrations.appName': 'اسم التطبيق',
    'admin.integrations.scopes': 'الصلاحيات',
    'admin.integrations.scope.products.read': 'قراية السلع',
    'admin.integrations.scope.inventory.read': 'قراية الستوك',
    'admin.integrations.scope.inventory.write': 'تبديل الستوك',
    'admin.integrations.scope.orders.read': 'قراية الكوموندات (بمعلومات الحرفاء)',
    'admin.integrations.scope.orders.write': 'معالجة الكوموندات (تأكيد، بعث، توصيل، تبطيل)',
    'admin.integrations.createApp': 'اعمل التطبيق',
    'admin.integrations.tokenTitle': 'كود «{name}»',
    'admin.integrations.tokenWarning': 'انسخ الكود هذا توّا: ما عادش يتعرض. ابعثو في Authorization: Bearer.',
    'admin.integrations.noApps': 'ما فماش تطبيقات.',
    'admin.integrations.column.name': 'الاسم',
    'admin.integrations.column.scopes': 'الصلاحيات',
    'admin.integrations.column.token': 'الكود',
    'admin.integrations.column.lastUsed': 'آخر استعمال',
    'admin.integrations.column.status': 'الحالة',
    'admin.integrations.column.result': 'النتيجة',
    'admin.integrations.never': 'عمرو',
    'admin.integrations.appStatus.active': 'خدّام',
    'admin.integrations.appStatus.revoked': 'تبطل',
    'admin.integrations.revoke': 'بطّل {name}',
    'admin.integrations.revoked': 'التطبيق تبطل: الكود متاعو ما عادش يخدم.',
    'admin.integrations.webhooks': 'الويبهوك',
    'admin.integrations.webhooksIntro': 'beinstore يبعث POST ممضي للعنوان متاعك في كل حدث تختارو. ثبّت في الإمضاء بالسر متاع العنوان.',
    'admin.integrations.webhooksDisabled': 'الويبهوك مازال ما تعدّاش على المنصة.',
    'admin.integrations.url': 'عنوان الاستقبال (https)',
    'admin.integrations.events': 'الأحداث',
    'admin.integrations.event.order.placed': 'كوموند جديدة',
    'admin.integrations.event.order.status_changed': 'تبدّل حالة الكوموند',
    'admin.integrations.event.order.payment_changed': 'تبدّل خلاص الكوموند',
    'admin.integrations.event.product.created': 'سلعة جديدة',
    'admin.integrations.event.product.updated': 'تبدّلت سلعة',
    'admin.integrations.event.product.deleted': 'تنحّات سلعة',
    'admin.integrations.event.inventory.availability_changed': 'تبدّل التوفر',
    'admin.integrations.event.invoice.issued': 'خرجت فاتورة',
    'admin.integrations.addEndpoint': 'زيد العنوان',
    'admin.integrations.noEndpoints': 'ما فماش عناوين.',
    'admin.integrations.endpointStatus.active': 'خدّام',
    'admin.integrations.endpointStatus.disabled': 'مسكّر',
    'admin.integrations.disabledByFailures': 'تسكّر بعد برشا فشل',
    'admin.integrations.secret': 'سر الإمضاء',
    'admin.integrations.showSecret': 'وري السر',
    'admin.integrations.rotateSecret': 'بدّل السر',
    'admin.integrations.rotated': 'سر جديد: القديم ما عادش يخدم.',
    'admin.integrations.ping': 'ابعث تجربة',
    'admin.integrations.pinged': 'التجربة في الطابور.',
    'admin.integrations.disable': 'سكّر',
    'admin.integrations.enable': 'عاود شعّل',
    'admin.integrations.delete': 'نحّي',
    'admin.integrations.deliveries': 'وري الإرسالات',
    'admin.integrations.noDeliveries': 'ما فماش إرسالات.',
    'admin.integrations.delivery.pending': 'يستنى',
    'admin.integrations.delivery.succeeded': 'نجح',
    'admin.integrations.delivery.failed': 'فشل',
    'admin.integrations.attempts': '{count, plural, one {محاولة وحدة} other {# محاولات}}',
    'admin.integrations.redeliver': 'عاود ابعث',
    'admin.integrations.redelivered': 'الإرسال رجع للطابور.',
    'admin.integrations.error.app': 'دخّل اسم وصلاحية وحدة على الأقل.',
    'admin.integrations.error.endpoint': 'دخّل عنوان وحدث واحد على الأقل.',
    'admin.integrations.error.url-scheme': 'استعمل عنوان https.',
    'admin.integrations.error.url-credentials': 'العنوان ما لازمش يكون فيه معرّفات دخول.',
    'admin.integrations.error.url-address': 'العنوان هذا موش مسموح (شبكة خاصة ولا محلية).',
    'admin.integrations.error.url-invalid': 'العنوان موش صحيح.',
    'admin.integrations.error.limit': 'وصلت للحد: نحّي ولا بطّل وحدة قبل.',
    'admin.integrations.error.version-conflict': 'العنوان تبدّل في الأثناء. عاود حمّل الصفحة.',
    // --- module 17: analytics, customer data ---
    'admin.analytics.title': 'الإحصائيات',
    'admin.analytics.definition': 'المبيعات = الكوموندات اللي ما تبطلتش وما ترجعتش (المبلغ الكل بالتوصيل والمعاليم). التواريخ بوقت تونس.',
    'admin.analytics.from': 'من',
    'admin.analytics.to': 'لـ',
    'admin.analytics.granularity': 'جمّع بـ',
    'admin.analytics.granularity.day': 'النهار',
    'admin.analytics.granularity.week': 'الجمعة',
    'admin.analytics.granularity.month': 'الشهر',
    'admin.analytics.exportOrders': 'صدّر كوموندات الفترة (CSV)',
    'admin.analytics.revenue': 'المبيعات',
    'admin.analytics.orders': 'الكوموندات',
    'admin.analytics.averageBasket': 'معدّل الباني',
    'admin.analytics.change': '{percent}٪ مقارنة بالفترة اللي قبلها',
    'admin.analytics.noComparison': 'ما فماش فترة قبلها نقارنو بيها',
    'admin.analytics.sales': 'المبيعات حسب الفترة',
    'admin.analytics.chartLabel': 'المبيعات من {from} لـ {to}: {total}',
    'admin.analytics.showTable': 'وري الأرقام',
    'admin.analytics.period': 'الفترة',
    'admin.analytics.topProducts': 'اللي يتباعو أكثر',
    'admin.analytics.noSales': 'ما فماش مبيعات في الفترة هذي.',
    'admin.analytics.byGovernorate': 'المبيعات حسب الولاية',
    'admin.analytics.region': 'الولاية',
    'admin.analytics.share': 'نسبة الكوموندات',
    'admin.analytics.funnel': 'متابعة الكوموندات',
    'admin.analytics.payments': 'الخلاص',
    'admin.analytics.range': 'الفترة',
    'admin.analytics.preset.7d': 'آخر 7 أيام',
    'admin.analytics.preset.30d': 'آخر 30 يوم',
    'admin.analytics.preset.90d': 'آخر 90 يوم',
    'admin.analytics.preset.month': 'هذا الشهر',
    'admin.analytics.itemsSold': 'قطع تباعت',
    'admin.analytics.cancelled': 'الإلغاءات',
    'admin.analytics.returned': 'المرتجعات',
    'admin.analytics.outcomes': 'الكوموندات والإلغاءات والمرتجعات',
    'admin.analytics.outcomesLabel': 'الكوموندات والإلغاءات والمرتجعات من {from} لـ {to}',
    'admin.analytics.catalog': 'الكاتالوغ',
    'admin.analytics.overview': 'نظرة على البوتيك',
    'admin.analytics.seeDashboard': 'حلّ لوحة المتابعة',
    'admin.privacy.title': 'معطيات الحرفاء',
    'admin.privacy.intro': 'جاوب على طلبات الحرفاء: لوّج على الكوموندات متاعهم، صدّر المعطيات ولا امسحها. المسح ينحّي الاسم والتليفون والإيمايل والعنوان والملاحظة؛ المبالغ والفواتير اللي خرجت يقعدو.',
    'admin.privacy.identifier': 'لوّج بـ',
    'admin.privacy.search': 'لوّج',
    'admin.privacy.found': '{count, plural, =0 {ما فماش كوموند فيها معطيات الحريف هذا.} one {كوموند وحدة فيها معطيات الحريف هذا.} other {# كوموندات فيهم معطيات الحريف هذا.}}',
    'admin.privacy.export': 'صدّر المعطيات (JSON)',
    'admin.privacy.exported': 'المعطيات تصدّرت.',
    'admin.privacy.eraseHint': 'الكوموندات لازم يكونو وصلو ولا تبطلو ولا ترجعو قبل المسح. ما تنجمش ترجع فيها.',
    'admin.privacy.erase': 'امسح المعطيات',
    'admin.privacy.confirm': 'نأكّد المسح النهائي للمعطيات الشخصية متاع الحريف هذا',
    'admin.privacy.erased': '{count, plural, one {المعطيات تمسحت من كوموند وحدة.} other {المعطيات تمسحت من # كوموندات.}}',
    'admin.privacy.log': 'تاريخ الطلبات',
    'admin.privacy.noLog': 'ما فماش طلبات.',
    'admin.privacy.kind.export': 'تصدير',
    'admin.privacy.kind.erase': 'مسح',
    'admin.privacy.kind.retention': 'مدة الحفظ',
    'admin.privacy.ordersAffected': '{count, plural, one {كوموند وحدة} other {# كوموندات}}',
    'admin.privacy.error.inProgress': 'فما كوموندات مازالت ماشية. {detail}',
    'admin.privacy.error.identifier': 'النومرو ولا الإيمايل موش صحيح.',
    'admin.privacy.erasedCustomer': 'حريف ممسوح',
    'admin.privacy.erasedOn': 'معطيات الحريف تمسحت نهار {date}.',
    // --- module 14: cash-on-delivery management ---
    'email.order.respond': 'أكّد الكوموند',
    'email.order.view': 'تابع الكوموند متاعي',
    'email.order.respondHint': 'أكّد الكوموند باش البوتيك تحضّرها.',
    'storefront.order.respondIntro': 'الخلاص كي توصلك: أكّد الكوموند باش البوتيك تحضّرها.',
    'storefront.order.confirm': 'نأكّد الكوموند',
    'storefront.order.cancel': 'نبطّل الكوموند',
    'storefront.order.confirmed': 'يعيشك، الكوموند متاعك تأكدت.',
    'storefront.order.cancelled': 'الكوموند متاعك تبطلت.',
    'storefront.order.actionFailed': 'الكوموند هذي ما عادش تنجم تبدّلها من هنا.',
    'admin.cod.title': 'الخلاص عند التسليم',
    'admin.cod.intro': 'تأكيد الكوموندات والتبطيل الأوتوماتيكي والنوامر المرفوضة.',
    'admin.cod.customerConfirmation': 'الحريف يأكّد الكوموند من صفحة الكوموند والإيمايل، وينجم يبطّلها بعد التأكيد',
    'admin.cod.autoCancelHours': 'بطّل الكوموندات اللي ما تأكدتش بعد (سوايع)',
    'admin.cod.autoCancelHint': 'خلّيه فارغ باش ما يتبطل شي وحدو. السلعة ترجع للستوك والحريف يوصلو إيمايل التبطيل.',
    'admin.cod.refusalThreshold': 'نبّه على نومرو من هالعدد متاع كوموندات راجعة',
    'admin.cod.refusalHint': 'يتحسب على كوموندات البوتيك متاعك برك. خلّيه فارغ باش ما تنبّه على شي.',
    'admin.cod.saved': 'الإعدادات تسجلت.',
    'admin.cod.blocked.title': 'نوامر ممنوعة من الخلاص عند التسليم',
    'admin.cod.blocked.hint': 'النوامر هذوما ما عادش ينجمو يختارو الخلاص عند التسليم في البوتيك متاعك. نحفظو آخر الأرقام برك.',
    'admin.cod.blocked.none': 'ما فماش نوامر.',
    'admin.cod.blocked.entry': 'نومرو يوفى بـ {hint}',
    'admin.cod.blocked.phone': 'نومرو التليفون',
    'admin.cod.blocked.reason': 'السبب (موش لازم)',
    'admin.cod.blocked.add': 'امنع النومرو هذا',
    'admin.cod.blocked.remove': 'رجّع النومرو اللي يوفى بـ {hint}',
    'admin.cod.panel': 'متابعة الخلاص عند التسليم',
    'admin.cod.firstOrder': 'أول كوموند من النومرو هذا في البوتيك متاعك.',
    'admin.cod.pastOrders': 'كوموندات أخرى من النومرو هذا: {delivered} وصلت، {returned} رجعت، {cancelled} تبطلت، {inProgress} ماشية.',
    'admin.cod.warning': 'ردّ بالك: {returned, plural, one {كوموند وحدة رجعت} other {# كوموندات رجعو}} للنومرو هذا.',
    'admin.cod.isBlocked': 'النومرو هذا ممنوع من الخلاص عند التسليم.',
    'admin.cod.calls': '{count, plural, =0 {ما فماش تليفونات مسجلة.} one {تليفون واحد مسجل.} other {# تليفونات مسجلة.}}',
    'admin.cod.logCall': 'سجّل التليفون',
    'admin.cod.outcome': 'نتيجة التليفون',
    'admin.cod.outcome.confirmed': 'الحريف أكّدها',
    'admin.cod.outcome.declined': 'الحريف رفضها',
    'admin.cod.outcome.no_answer': 'ما جاوبش',
    'admin.cod.outcome.unreachable': 'النومرو مسكّر ولا غالط',
    'admin.cod.outcome.callback': 'عاود اطلبو من بعد',
    'admin.cod.outcomeHint': '«الحريف أكّدها» تأكّد الكوموند؛ «الحريف رفضها» تبطّلها وترجّع السلعة للستوك.',
    'admin.cod.callNote': 'ملاحظة (موش لازم)',
    'admin.cod.callLogged': 'التليفون تسجل.',
    'admin.cod.block': 'امنع الخلاص عند التسليم على النومرو هذا',
    'admin.cod.unblock': 'اقبل النومرو هذا من جديد',
    'admin.cod.blockedDone': 'النومرو تمنع من الخلاص عند التسليم.',
    'admin.cod.unblockedDone': 'النومرو تقبل من جديد.',
    'admin.cod.error.phone': 'نومرو التليفون موش صحيح.',
    'admin.cod.history.call': 'تليفون: {outcome}',
    'admin.order.history.byCustomer': 'من الحريف',
    'admin.order.history.automatic': 'أوتوماتيكيًا',
    // --- module 13: shipping by settings ---
    'email.shipment.carrier': 'شركة التوصيل: {carrier}',
    'email.shipment.line': '{carrier} — نومرو التتبع: {tracking}',
    'email.shipment.ownDelivery': 'توصيل من البوتيك',
    'email.shipment.track': 'تبّع الكولي متاعي',
    'email.shipment.subject': 'كولي آخر من الكوموند نومرو {number} في الثنية – {store}',
    'email.shipment.heading': 'كولي آخر في الثنية',
    'email.shipment.intro': '{store} بعثلك جزء آخر من الكوموند نومرو {number}.',
    'deliveryNote.title': 'بون التوصيل',
    'deliveryNote.reference': 'المرجع: {reference}',
    'deliveryNote.date': 'التاريخ: {date}',
    'deliveryNote.recipient': 'اللي باش يستلم',
    'deliveryNote.carrier': 'شركة التوصيل',
    'deliveryNote.ownDelivery': 'توصيل من البوتيك',
    'deliveryNote.tracking': 'نومرو التتبع: {tracking}',
    'deliveryNote.collect': 'الفلوس اللي تتلم عند التسليم: {amount}',
    'deliveryNote.nothingToCollect': 'ما فما شي يتلم عند التسليم',
    'deliveryNote.column.item': 'السلعة',
    'deliveryNote.column.quantity': 'الكمية',
    'deliveryNote.customerNote': 'ملاحظة الحريف',
    'storefront.order.shipments': 'الكوليات',
    'storefront.order.shipment': 'الكولي {number}',
    'storefront.order.shipment.shipped': 'في الثنية',
    'storefront.order.shipment.delivered': 'وصل',
    'storefront.order.shipment.returned': 'رجع',
    'storefront.order.shipment.ownDelivery': 'توصيل من البوتيك',
    'storefront.order.shipment.tracking': 'نومرو التتبع: {tracking}',
    'storefront.order.shipment.track': 'تبّع الكولي {number}',
    'admin.carriers.title': 'شركات التوصيل',
    'admin.carriers.intro': 'شركات التوصيل اللي تخدم معاهم. ما فماش ربط مع السيستام متاعهم: تكتب نومرو التتبع كي تبعث.',
    'admin.carriers.none': 'ما فماش شركات توصيل.',
    'admin.carriers.name': 'الإسم',
    'admin.carriers.phone': 'التليفون (موش لازم)',
    'admin.carriers.trackingUrl': 'رابط التتبع (موش لازم)',
    'admin.carriers.trackingUrlHint': 'يبدا بـ https:// وفيه {placeholder} اللي يتبدّل بنومرو التتبع.',
    'admin.carriers.defaultFee': 'المعلوم العادي لكل كولي (د.ت، موش لازم)',
    'admin.carriers.active': 'اقترح شركة التوصيل هذي كي تبعث',
    'admin.carriers.add': 'زيد شركة التوصيل',
    'admin.carriers.edit': 'بدّل {name}',
    'admin.carriers.added': 'شركة التوصيل تزادت.',
    'admin.carriers.saved': 'شركة التوصيل تسجلت.',
    'admin.carriers.inactive': 'موش مفعّل',
    'admin.carriers.error.conflict': 'فما شركة توصيل بنفس الإسم (ولا وصلت للحد).',
    'admin.carriers.error.validation': 'ثبّت في الإسم والتليفون ورابط التتبع والمعلوم.',
    'admin.shipment.title': 'الكوليات',
    'admin.shipment.none': 'ما تبعث حتى كولي.',
    'admin.shipment.number': 'الكولي {number}',
    'admin.shipment.ownDelivery': 'توصيل من البوتيك',
    'admin.shipment.status.shipped': 'في الثنية',
    'admin.shipment.status.delivered': 'وصل',
    'admin.shipment.status.returned': 'رجع',
    'admin.shipment.tracking': 'التتبع: {tracking}',
    'admin.shipment.cod': 'يتلم: {amount}',
    'admin.shipment.fee': 'معلوم التوصيل: {amount}',
    'admin.shipment.items': '{count, plural, one {سلعة وحدة} other {# سلع}}',
    'admin.shipment.markDelivered': 'علّم الكولي {number} اللي وصل',
    'admin.shipment.markReturned': 'علّم الكولي {number} اللي رجع',
    'admin.shipment.note': 'بون توصيل الكولي {number} ({language})',
    'admin.shipment.new': 'ابعث كولي',
    'admin.shipment.quantity': 'الكمية اللي باش تتبعث: {item}',
    'admin.shipment.left': 'باقي {count}',
    'admin.shipment.carrier': 'شركة التوصيل',
    'admin.shipment.trackingNumber': 'نومرو التتبع (موش لازم)',
    'admin.shipment.feeLabel': 'معلوم التوصيل (د.ت، موش لازم)',
    'admin.shipment.feeHint': 'فارغ: المعلوم العادي متاع شركة التوصيل.',
    'admin.shipment.codLabel': 'اللي يتلم عند التسليم (د.ت، موش لازم)',
    'admin.shipment.codHint': 'فارغ: الباقي الكل.',
    'admin.shipment.create': 'ابعث',
    'admin.shipment.created': 'الكولي تسجل.',
    'admin.shipment.updated': 'الكولي تبدّل.',
    'admin.shipment.error.validation': 'ثبّت في الكميات (موش أكثر من الباقي) ونومرو التتبع والمبالغ (موش أكثر من اللي باقي يتلم).',
    'admin.shipment.error.empty': 'اختار سلعة وحدة على الأقل.',
    'admin.order.history.shipment': 'الكولي {number}: {status}',
    // --- module 12: cash-on-delivery payments ---
    'admin.cash.title': 'الخلاص',
    'admin.cash.total': 'مجموع الكوموند: {amount}',
    'admin.cash.collected': 'اللي تخلص: {amount}',
    'admin.cash.refunded': 'اللي ترجع: {amount}',
    'admin.cash.due': 'الباقي يتخلص: {amount}',
    'admin.cash.none': 'ما فما حتى خلاص.',
    'admin.cash.kind.collection': 'خلاص',
    'admin.cash.kind.refund': 'ترجيع فلوس',
    'admin.cash.kind.reversal': 'تبطيل',
    'admin.cash.byCarrier': 'عند {carrier}',
    'admin.cash.byMerchant': 'عند البوتيك',
    'admin.cash.parcel': 'الكولي {number}',
    'admin.cash.automatic': 'أوتوماتيكي',
    'admin.cash.reversed': 'متبطل',
    'admin.cash.remitted': 'الموزع سلّمو',
    'admin.cash.reverse': 'بطّل الكتيبة متاع {date}',
    'admin.cash.reversedDone': 'الكتيبة تبطلت.',
    'admin.cash.collect': 'سجّل خلاص',
    'admin.cash.amount': 'المبلغ (د.ت)',
    'admin.cash.collector': 'خلّصو',
    'admin.cash.merchant': 'البوتيك',
    'admin.cash.note': 'ملاحظة (موش لازم)',
    'admin.cash.collectedDone': 'الخلاص تسجل.',
    'admin.cash.refund': 'سجّل ترجيع فلوس',
    'admin.cash.refundedDone': 'الترجيع تسجل.',
    'admin.cash.error.amount': 'المبلغ موش صحيح: ما يفوتش الباقي (ولا اللي تخلص، كي ترجّع).',
    'admin.cash.error.reverse': 'الكتيبة هذي ما تتبطلش (متبطلة، ولا الموزع سلّم الفلوس: سجّل ترجيع).',
    'admin.payments.title': 'الخلاص والموزعين',
    'admin.payments.intro': 'الخلاص عند التسليم: الموزعين يرجعولك الفلوس اللي لمّوها، ناقصين المعاليم متاعهم.',
    'admin.payments.inHand': 'في الكاسة: {amount}',
    'admin.payments.withCarriers': 'عند الموزعين: {amount}',
    'admin.payments.owed': '{name} يتسالك {amount} ({count, plural, one {خلاص واحد} other {# خلاصات}})',
    'admin.payments.lastRemittance': 'آخر تسليم: {date}',
    'admin.payments.remit': 'سجّل تسليم من {name}',
    'admin.payments.order': 'الكوموند نومرو {number}',
    'admin.payments.fees': 'المعاليم اللي خذاها الموزع (د.ت)',
    'admin.payments.feesHint': 'المقترح: معاليم الكوليات ({amount}).',
    'admin.payments.receivedAt': 'تاريخ التسليم',
    'admin.payments.net': 'المبلغ اللي وصلك: {amount}',
    'admin.payments.save': 'سجّل التسليم',
    'admin.payments.saved': 'التسليم تسجل.',
    'admin.payments.history': 'التسليمات',
    'admin.payments.remittance': '{date} — {name}: وصلك {net} ({gross} تلمّت، {fees} معاليم)',
    'admin.payments.none': 'ما فما حتى تسليم.',
    'admin.payments.nothingOwed': 'ما فما شي باقي عند الموزع هذا.',
    'admin.payments.error.select': 'اختار خلاص واحد على الأقل.',
    'admin.payments.error.stale': 'الخلاصات هذوما ما عادش باقين: عاود حمّل الصفحة.',
    // --- module 15: billing, custom domains, operator console ---
    'platformInvoice.title': 'فاتورة',
    'platformInvoice.taxId': 'المعرف الجبائي: {taxId}',
    'platformInvoice.number': 'نومرو {number}',
    'platformInvoice.date': 'التاريخ: {date}',
    'platformInvoice.billTo': 'الفاتورة باسم',
    'platformInvoice.column.description': 'البيان',
    'platformInvoice.column.amount': 'المبلغ',
    'platformInvoice.line': 'اشتراك {plan} — {months} شهر، من {from} لـ {to}',
    'platformInvoice.net': 'المجموع من غير الأداء على القيمة المضافة',
    'platformInvoice.vat': 'الأداء على القيمة المضافة {rate}٪',
    'platformInvoice.total': 'المجموع',
    'platformInvoice.paid': 'تخلّص بـ {method} نهار {date}',
    'platformInvoice.method.bank_transfer': 'تحويل بنكي',
    'platformInvoice.method.cash': 'كاش',
    'platformInvoice.method.other': 'طريقة أخرى',
    'platformInvoice.reference': 'المرجع: {reference}',
    'admin.error.subscription-restricted': 'الاشتراك موش خالص: الكوموندات برك تنجم تتبدل حتى للخلاص.',
    'admin.error.plan-limit-reached': 'وصلت للحد متاع الباقة: بدّل لباقة أكبر باش تزيد.',
    'admin.billing.title': 'الاشتراك',
    'admin.billing.none': 'البوتيك متاعك ما عندهاش باقة توا.',
    'admin.billing.plan': 'الباقة: {name}',
    'admin.billing.price': '{amount} كل {months, plural, one {شهر} other {# شهور}}',
    'admin.billing.state.none': 'من غير اشتراك.',
    'admin.billing.state.free': 'باقة بلاش.',
    'admin.billing.state.trialing': 'تجربة بلاش حتى {date}.',
    'admin.billing.state.active': 'خالص حتى {date}.',
    'admin.billing.state.grace': 'الخلاص متأخر: الإدارة تولّي للقراية برك نهار {date} (الكوموندات تقعد تخدم).',
    'admin.billing.state.restricted': 'الاشتراك موش خالص: الإدارة للقراية برك، كان الكوموندات، حتى للخلاص.',
    'admin.billing.howToPay': 'فريق beinstore يسجّل الخلاص، ومن بعد الفاتورة تظهر هنا.',
    'admin.billing.usage': 'الاستعمال',
    'admin.billing.kind.products': 'السلع',
    'admin.billing.kind.staff': 'أعضاء الفريق',
    'admin.billing.kind.customDomains': 'الدومينات الخاصة',
    'admin.billing.usageLine': '{kind}: {used} من {limit}',
    'admin.billing.usageUnlimited': '{kind}: {used} (بلا حد)',
    'admin.billing.invoices': 'فواتير beinstore',
    'admin.billing.noInvoices': 'ما فما حتى فاتورة.',
    'admin.billing.invoice': 'الفاتورة {number} متاع {date} — {amount} (PDF)',
    'admin.billing.details': 'شوف الاشتراك',
    'admin.domains.title': 'عناوين البوتيك',
    'admin.domains.intro': 'البوتيك متاعك ديما موجودة على العنوان متاعها في beinstore. تنجم زادة تستعمل الدومين متاعك.',
    'admin.domains.unavailable': 'الدومينات الخاصة مازالت موش موجودة في المنصة.',
    'admin.domains.kind.platform_subdomain': 'عنوان beinstore',
    'admin.domains.kind.custom': 'دومين خاص',
    'admin.domains.status.pending_verification': 'يستنى في التثبت',
    'admin.domains.status.active': 'مفعّل',
    'admin.domains.canonical': 'العنوان الرئيسي',
    'admin.domains.host': 'إسم الدومين (مثلًا shop.example.tn)',
    'admin.domains.add': 'زيد الدومين',
    'admin.domains.added': 'الدومين تزاد: اعمل الـ DNS ومن بعد ثبّت.',
    'admin.domains.instructions': 'اعمل الـ records هذوما عند اللي شريت منو الدومين:',
    'admin.domains.txt': 'سجل TXT {name} = {value}',
    'admin.domains.cname': 'سجل CNAME {name} → {target}',
    'admin.domains.verify': 'ثبّت {host}',
    'admin.domains.verified': 'الدومين تثبّت.',
    'admin.domains.makeCanonical': 'استعمل {host} كعنوان رئيسي',
    'admin.domains.canonicalDone': 'العنوان الرئيسي تبدّل.',
    'admin.domains.remove': 'نحّي {host}',
    'admin.domains.removed': 'الدومين تنحّى.',
    'admin.domains.error.notVerified': 'ما لقيناش الـ record متاع التثبت. تبديلات الـ DNS تنجم تاخو وقت.',
    'admin.domains.error.invalid': 'إسم الدومين موش صحيح (لازم يكون برا دومين المنصة).',
    'admin.domains.error.taken': 'الدومين هذا مستعمل.',
    'admin.nav.operator': 'كونسول المشغّل',
    'admin.operator.title': 'كونسول المشغّل',
    'admin.operator.stores': 'الحوانت',
    'admin.operator.plans': 'الباقات',
    'admin.operator.settings': 'إعدادات الفوترة',
    'admin.console.tagline': 'الباقات والاشتراكات والفواتير متاع البوتيكات الكل في بي إن ستور.',
    'admin.console.note': 'مخصّص للمشغّلين متاع منصة بي إن ستور.',
    'admin.landing.title': 'الصفحة الرئيسية',
    'admin.landing.intro': 'النصوص متاع الصفحة العامة beinstore.tn. الباقات هوما اللي معروضين في التسجيل. اللي فارغ ما يبانش.',
    'admin.landing.language': 'اللغة اللي تبدّل فيها',
    'admin.landing.features': 'المزايا',
    'admin.landing.feature': 'الميزة {number}',
    'admin.landing.featureTitle': 'العنوان ({language})',
    'admin.landing.featureText': 'النص ({language})',
    'admin.landing.addFeature': 'زيد ميزة',
    'admin.landing.faq': 'الأسئلة والأجوبة',
    'admin.landing.question': 'السؤال {number}',
    'admin.landing.questionText': 'السؤال ({language})',
    'admin.landing.answer': 'الجواب ({language})',
    'admin.landing.addQuestion': 'زيد سؤال',
    'admin.landing.remove': 'نحّي',
    'admin.landing.links': 'الصفحات القانونية',
    'admin.landing.terms': 'شروط الاستعمال (العنوان)',
    'admin.landing.privacy': 'سياسة الخصوصية (العنوان)',
    'admin.landing.linkHint': 'عنوان https متاع صفحة عندك. فارغ = ما فماش رابط.',
    'admin.landing.saved': 'الصفحة الرئيسية تسجّلت.',
    'admin.landing.invalid': 'ثبّت في النصوص والعناوين (https برك).',
    'landing.title': 'بي إن ستور — البوتيك متاعك على النت في تونس',
    'landing.skip': 'امشي للمحتوى',
    'landing.language': 'اللغة',
    'landing.signIn': 'أدخل',
    'landing.cta': 'أعمل البوتيك متاعي',
    'landing.compare': 'قارن الباقات',
    'landing.plans': 'الباقات',
    'landing.noPlans': 'ما فماش باقة متوفرة توّا.',
    'landing.choose': 'اختار الباقة هاذي',
    'landing.chooseNamed': 'اختار باقة {name}',
    'landing.free': 'بلاش',
    'landing.price': '{amount} كل {months, plural, one {شهر} other {# شهور}}',
    'landing.trial': 'تجربة بلاش: {days, plural, one {نهار} other {# أيام}}',
    'landing.limit.products': 'السلع: {count}',
    'landing.limit.staff': 'أعضاء الفريق: {count}',
    'landing.limit.domains': 'الدومينات الخاصة: {count}',
    'landing.unlimited': 'بلا حدّ',
    'landing.features': 'المزايا',
    'landing.faq': 'الأسئلة والأجوبة',
    'landing.terms': 'شروط الاستعمال',
    'landing.privacy': 'سياسة الخصوصية',
    'landing.error': 'الصفحة ما تحلّتش. عاود بعد شوية.',
    'landing.menu': 'في الصفحة هاذي',
    'landing.vision.title': 'الرؤية',
    'landing.vision.body': 'كل بوتيك في تونس لازمو يقدر ياخذ كوموند، يوصّلها ويخلّص فلوسها في بلاصة وحدة، باللغة اللي يقراها الحريف.',
    'landing.about.title': 'شكون احنا',
    'landing.about.body': 'بي إن ستور هي المنصة هاذي. التاجر يحل البوتيك، يختار باقة ويبيع. الحريف يعمل كوموند، يخلّص عند الاستلام ولا بالتحويل، ويتبع الكوموند متاعو. البوتيك بالعربي والفرنساوي والتونسي والإنقليزي.',
    'landing.about.merchantTitle': 'التاجر',
    'landing.about.merchant': 'التاجر يحل البوتيك، يختار باقة ويبيع.',
    'landing.about.customerTitle': 'الحريف',
    'landing.about.customer': 'الحريف يعمل كوموند، يخلّص عند الاستلام ولا بالتحويل، ويتبع الكوموند متاعو.',
    'landing.about.languagesTitle': 'أربع لغات',
    'landing.about.languages': 'البوتيك بالعربي والفرنساوي والتونسي والإنقليزي.',
    'landing.contact.title': 'كلّمنا',
    'landing.contact.body': 'سؤال على باقة ولا بوتيك: اكتبولنا. التاجر اللي عندو بوتيك يدخل.',
    'landing.contact.write': 'اكتبولنا',
    'landing.legal.title': 'السياسات',
    'landing.legal.termsBody': 'التاجر يختار باقة، وبعد يستعمل بي إن ستور لبوتيك واحد. السعر والتجربة هما اللي مكتوبين في الصفحة هاذي.',
    'landing.legal.privacyBody': 'نستعملو معطيات دخول التاجر باش يخدم البوتيك، وتفاصيل الكوموند باش نوصلوها. ما نبيعوش المعطيات هاذي.',
    'landing.legal.addressLabel': 'عنوان السياسة',
    'landing.footer.product': 'المنتج',
    'landing.place': 'تونس',
    'admin.setup.title': 'حضّر البوتيك متاعك',
    'admin.setup.progress': 'المرحلة {current} من {total}',
    'admin.setup.steps': 'المراحل',
    'admin.setup.done': 'كمل',
    'admin.setup.todo': 'مازال',
    'admin.setup.optional': 'اختياري',
    'admin.setup.required': 'لازم',
    'admin.setup.skip': 'فوّت المرحلة هاذي',
    'admin.setup.continue': 'كمّل',
    'admin.setup.saveContinue': 'سجّل وكمّل',
    'admin.setup.banner': 'البوتيك هاذي مازالت مش منشورة: الكليان ما يشوفوهاش.',
    'admin.setup.finish': 'كمّل التحضير',
    'admin.setup.step.plan': 'الباقة',
    'admin.setup.step.contact': 'معلومات الاتصال',
    'admin.setup.step.legal': 'المعلومات القانونية',
    'admin.setup.step.delivery': 'التوصيل والخلاص',
    'admin.setup.step.products': 'السلع',
    'admin.setup.step.publish': 'النشر',
    'admin.setup.plan.title': 'اختار الباقة متاعك',
    'admin.setup.plan.none': 'ما فماش باقة تختارها توّا: كمّل.',
    'admin.setup.plan.free': 'بلاش',
    'admin.setup.plan.trial': 'تجربة بلاش: {days, plural, one {نهار} other {# أيام}}',
    'admin.setup.plan.limits': 'السلع: {products} · أعضاء الفريق: {staff}',
    'admin.setup.plan.unlimited': 'بلا حدّ',
    'admin.setup.plan.locked': 'البوتيك منشورة ولا مخلّصة: كلّم beinstore باش تبدّل الباقة.',
    'admin.setup.contact.title': 'كيفاش الكليان يكلموك',
    'admin.setup.contact.intro': 'تبان لوطة في كل صفحة من البوتيك.',
    'admin.setup.contact.phone': 'التليفون',
    'admin.setup.contact.email': 'الإيميل متاع الاتصال',
    'admin.setup.contact.governorate': 'الولاية',
    'admin.setup.contact.choose': 'اختار…',
    'admin.setup.contact.address': 'العنوان (اختياري)',
    'admin.setup.contact.governorateMissing': 'اختار الولاية متاعك.',
    'admin.setup.legal.title': 'المعلومات القانونية متاعك',
    'admin.setup.legal.intro': 'تتطبع على الفواتير اللي تعطيها للكليان.',
    'admin.setup.legal.name': 'الإسم القانوني ({language})',
    'admin.setup.legal.address': 'عنوان المقر ({language})',
    'admin.setup.legal.taxId': 'الماتريكول الجبائي',
    'admin.setup.legal.taxIdHint': 'اختياري كان موش مسجّل.',
    'admin.setup.legal.more': 'إعدادات الفوترة الكل',
    'admin.setup.delivery.title': 'كيفاش الكليان يخلّصو ويوصلهم الكوموند',
    'admin.setup.delivery.intro': 'يلزم على الأقل طريقة خلاص وطريقة توصيل باش توصلك الكوموندات.',
    'admin.setup.delivery.incomplete': 'اختار على الأقل طريقة خلاص، والاستلام من البوتيك ولا مناطق توصيل.',
    'admin.setup.delivery.bankInstructions': 'تعليمات الفيرمون',
    'admin.setup.delivery.shipping': 'التوصيل للدار',
    'admin.setup.delivery.zones': '{count, plural, =0 {مازال ما فماش مناطق توصيل.} one {منطقة توصيل وحدة.} other {# مناطق توصيل.}}',
    'admin.setup.delivery.zonesLink': 'حدّد مناطق التوصيل والأسوام حسب الولاية',
    'admin.setup.delivery.pickupAddress': 'عنوان الاستلام',
    'admin.setup.products.title': 'زيد أول سلعك',
    'admin.setup.products.intro': 'يلزم على الأقل سلعة للبيع، بسوم وستوك، باش تنشر.',
    'admin.setup.products.ready': 'عندك سلعة حاضرة للبيع.',
    'admin.setup.products.added': 'السلع اللي تزادت',
    'admin.setup.products.form': 'سلعة جديدة',
    'admin.setup.products.name': 'الإسم',
    'admin.setup.products.price': 'السوم (د.ت)',
    'admin.setup.products.stock': 'الكمية في الستوك',
    'admin.setup.products.photo': 'تصويرة (اختياري)',
    'admin.setup.products.add': 'زيد السلعة',
    'admin.setup.products.more': 'المحرّر الكامل متاع السلع',
    'admin.setup.products.invalid': 'اكتب إسم وسوم أكثر من صفر.',
    'admin.setup.publish.title': 'انشر البوتيك متاعك',
    'admin.setup.publish.intro': 'شوفها بالمعاينة، ومبعد انشرها: الكليان ينجمو يدخلو ويكومنديو.',
    'admin.setup.publish.missing': '{count, plural, one {مرحلة لازمة مازالت ما كملتش.} other {# مراحل لازمة مازالت ما كملوش.}}',
    'admin.setup.publish.preview': 'عاين البوتيك',
    'admin.setup.publish.action': 'انشر البوتيك متاعي',
    'admin.setup.publish.online': 'البوتيك متاعك توّا على النت.',
    'admin.setup.publish.toStore': 'امشي للوحة البوتيك',
    'admin.setup.publish.policies': 'إنتي البائع. السلع الممنوعة ماهيش مسموحة. beinstore تنجّم تخبّي عرض ولا توقّف البوتيك.',
    'admin.setup.publish.accept': 'قريت ونقبل شروط الاستعمال وسياسة الخصوصية',
    'admin.billing.paymentInstructions': 'كيفاش تخلّص',
    'admin.operator.plan.offered': 'التسجيل',
    'admin.operator.plan.offeredHint': 'معروضة على التجّار الجدد في مساعد التحضير',
    'admin.operator.set.paymentInstructionsIn': 'تعليمات الخلاص للتجّار ({language})',
    'admin.operator.set.paymentInstructionsHint': 'مثلًا الريب متاع beinstore. تبان في مرحلة الباقة وصفحة الاشتراك.',
    'admin.operator.set.requiredSteps': 'المراحل اللازمة قبل ما تتنشر بوتيك جديدة',
    'admin.error.onboarding-incomplete': 'فمّا مراحل لازمة مازالت ما كملتش.',
    'admin.error.terms-not-accepted': 'اقبل شروط الاستعمال قبل ما تنشر.',
    'storefront.contact': 'اتصل بينا',
    'admin.error.operator-account': 'هذا كونت مشغّل متاع المنصة. أدخل من كونسول المشغّل.',
    'admin.error.merchant-account': 'هذا الكونت مربوط ببوتيكات. المشغّلين متاع المنصة يلزمهم كونت وحدو.',
    'admin.operator.search': 'لوّج على بوتيك',
    'admin.operator.noStores': 'ما فما حتى بوتيك.',
    'admin.operator.stores.intro': 'كل بوتيك والباقة متاعو: آخر خلاص، التجديد والوعد. بحث وتصفية وترتيب.',
    'admin.operator.planFilter': 'الباقة',
    'admin.operator.plan.any': 'كل الباقات',
    'admin.operator.stateFilter': 'الاشتراك',
    'admin.operator.state.any': 'كل الحالات',
    'admin.operator.renew': 'التجديد',
    'admin.operator.deadline': 'الوعد',
    'admin.operator.lastPayment': 'آخر خلاص',
    'admin.operator.noPayment': 'ما فماش',
    'admin.operator.noPlan': 'من غير باقة',
    'admin.operator.stateShort.none': 'من غير اشتراك',
    'admin.operator.stateShort.free': 'بلاش',
    'admin.operator.stateShort.trialing': 'تجربة',
    'admin.operator.stateShort.active': 'خالص',
    'admin.operator.stateShort.grace': 'متأخر',
    'admin.operator.stateShort.restricted': 'مقيّد',
    'admin.operator.plan.new': 'باقة جديدة',
    'admin.operator.plan.edit': 'بدّل {code}',
    'admin.operator.plan.code': 'الكود',
    'admin.operator.plan.nameIn': 'الإسم بالـ{language}',
    'admin.operator.plan.price': 'السوم لكل فترة (د.ت)',
    'admin.operator.plan.period': 'الفترة',
    'admin.operator.plan.months': '{count, plural, one {شهر} other {# شهور}}',
    'admin.operator.plan.trialDays': 'أيام التجربة بلاش',
    'admin.operator.plan.graceDays': 'أيام المهلة بعد آخر أجل',
    'admin.operator.plan.maxProducts': 'أقصى عدد سلع (فارغ = بلا حد)',
    'admin.operator.plan.maxStaff': 'أقصى عدد أعضاء (فارغ = بلا حد)',
    'admin.operator.plan.maxDomains': 'أقصى عدد دومينات خاصة (فارغ = بلا حد)',
    'admin.operator.plan.active': 'مقترح للحوانت',
    'admin.operator.plan.create': 'اعمل الباقة',
    'admin.operator.plan.saved': 'الباقة تسجلت.',
    'admin.operator.plan.error': 'ثبّت في الكود (ما يتعاودش) والإسم والسوم والقيم.',
    'admin.operator.plan.empty': 'ما فماش باقات.',
    'admin.operator.plan.subscribers': 'الحوانت المشتركين',
    'admin.operator.plan.subscriberCount': '{count, plural, one {حانوت} other {# حوانت}}',
    'admin.operator.plan.delete': 'امسح الباقة',
    'admin.operator.plan.confirmDelete': 'أكّد مسح الباقة',
    'admin.operator.plan.deleted': 'الباقة تمشات.',
    'admin.operator.plan.cannotDelete.subscribers': 'فما حوانت مازالوا على الباقة. حوّلهم لباقة أخرى أوّلا.',
    'admin.operator.plan.cannotDelete.payments': 'تسجلوا خلاصات على الباقة. حيّدها من العرض بدل ما تمسحها.',
    'admin.operator.plan.cannotDelete.default': 'هاذي باقة الحوانت الجدد. بدّلها في إعدادات الفوترة أوّلا.',
    'admin.operator.set.legalNameIn': 'الإسم القانوني متاع beinstore ({language})',
    'admin.operator.set.addressIn': 'عنوان beinstore ({language})',
    'admin.operator.set.taxId': 'المعرف الجبائي متاع beinstore (موش لازم)',
    'admin.operator.set.footerIn': 'أسفل الفاتورة ({language}، موش لازم)',
    'admin.operator.set.prefix': 'بداية نوامر الفواتير',
    'admin.operator.set.vatRate': 'نسبة الأداء على القيمة المضافة بالمية (فارغ = من غير)',
    'admin.operator.set.pricesIncludeVat': 'أسوام الباقات فيها الأداء على القيمة المضافة',
    'admin.operator.set.defaultPlan': 'باقة الحوانت الجداد',
    'admin.operator.set.noDefault': 'حتى شي (من غير اشتراك)',
    'admin.operator.set.saved': 'الإعدادات تسجلت.',
    'admin.operator.assign': 'طبّق الباقة',
    'admin.operator.assigned': 'الباقة تطبّقت.',
    'admin.operator.payment': 'سجّل خلاص',
    'admin.operator.periods': 'عدد الفترات',
    'admin.operator.amount': 'المبلغ (د.ت، فارغ = السوم × الفترات)',
    'admin.operator.method': 'طريقة الخلاص',
    'admin.operator.method.bank_transfer': 'تحويل بنكي',
    'admin.operator.method.cash': 'كاش',
    'admin.operator.method.other': 'أخرى',
    'admin.operator.reference': 'المرجع (موش لازم)',
    'admin.operator.receivedAt': 'تاريخ الوصول',
    'admin.operator.invoiceLanguage': 'لغة الفاتورة',
    'admin.operator.paid': 'الخلاص تسجل والفاتورة خرجت.',
    'admin.operator.payments': 'الخلاصات',
    'admin.operator.noPayments': 'ما فما حتى خلاص.',
    'admin.operator.paymentLine': '{date} — {amount} — {periods, plural, one {فترة} other {# فترات}} ({from} → {to})',
    'admin.operator.error.settings': 'اكتب الأول الإسم القانوني وعنوان beinstore في إعدادات الفوترة.',
    'admin.operator.error.noPlan': 'طبّق الأول باقة على البوتيك هاذي.',
    'email.shopperCode.subject': 'الكود متاع {store}: {code}',
    'email.shopperCode.heading': 'الكود متاع الدخول',
    'email.shopperCode.intro': 'استعمل الكود هذا باش تحل الحساب متاعك عند {store}:',
    'email.shopperCode.expiry': 'يوفى بعد {minutes, plural, zero {# دقيقة} one {دقيقة} two {دقيقتين} few {# دقايق} many {# دقيقة} other {# دقيقة}} وما يتستعملش كان مرة وحدة.',
    'email.shopperCode.ignore': 'كان موش انت اللي طلبتو، ما تعمل شي: حتى حد ما ينجم يدخل من غير الكود هذا.',
    'storefront.account.nav': 'الحساب متاعي',
    'storefront.account.signIn': 'دخول',
    'storefront.account.title': 'الحساب متاعي',
    'storefront.account.orders': 'الكوموندات متاعي',
    'storefront.account.addresses': 'العناوين متاعي',
    'storefront.account.profile': 'المعلومات متاعي',
    'storefront.account.signOut': 'خروج',
    'storefront.account.phone': 'التيليفون',
    'storefront.account.email': 'الإيمايل',
    'storefront.account.name': 'الإسم واللقب',
    'storefront.account.sendCode': 'ابعثلي كود',
    'storefront.account.code': 'الكود اللي جاك في الإيمايل',
    'storefront.account.verify': 'كمّل',
    'storefront.account.sent': 'كان النومرو هذا ينجم يوصلو كود، تبعث في الإيمايل.',
    'storefront.account.invalidCode': 'الكود غالط ولاّ فات وقتو.',
    'storefront.account.save': 'سجّل',
    'storefront.account.saved': 'تسجّل.',
    'storefront.account.emailChange': 'بدّل الإيمايل',
    'storefront.account.emailHint': 'الكود يتبعث للعنوان الجديد.',
    'storefront.account.noOrders': 'ما فما حتى كوموند توّا.',
    'storefront.account.addAddress': 'زيد عنوان',
    'storefront.account.saveAddress': 'سجّل العنوان',
    'storefront.account.removeAddress': 'احذف',
    'storefront.account.defaultAddress': 'العنوان الأساسي',
    'storefront.account.makeDefault': 'خلّيه الأساسي',
    'storefront.account.addressLimit': 'عشرة عناوين على الأكثر.',
    'storefront.account.cancelOrder': 'ألغي الكوموند هاذي',
    'storefront.account.returnRequest': 'نحب نرجّع',
    'storefront.account.returnMessage': 'شنوّة تحب ترجّعو؟',
    'storefront.account.returnSend': 'ابعث الطلب',
    'storefront.account.returnStatus.requested': 'الطلب تبعث ومستني البوتيك',
    'storefront.account.returnStatus.accepted': 'الرجوع تقبل',
    'storefront.account.returnStatus.declined': 'الطلب ترفض',
    'storefront.account.cancelClosed': 'الكوموند هاذي ما عادش تنجم تتلغى.',
    'storefront.account.phoneLocked': 'النومرو ما يتبدّلش.',
    'storefront.account.newAccount': 'أول مرة: اكتب الإسم والإيمايل زادا.',
    'storefront.account.back': 'ارجع للكوموندات متاعي',
    'storefront.account.cancelled': 'الكوموند متاعك تلغات.',
    'storefront.account.returnSent': 'الطلب متاعك تبعث.',
    'storefront.account.declineNote': 'ملاحظة البوتيك: {note}',
    'storefront.account.error': 'العملية ما نجحتش. عاود.',
    'storefront.account.ordered': 'تاريخ الكوموند',
    'storefront.account.payment': 'الخلاص',
    'storefront.account.delivery': 'التوصيل',
    'storefront.account.deliveryDate': 'تاريخ التسليم',
    'storefront.account.plannedDelivery': 'التسليم المتوقع',
    'storefront.account.notDelivered': 'ما وصلش توّا',
    'storefront.account.notScheduled': 'ما تحددش توّا',
    'storefront.account.homeDelivery': 'توصيل للدار — {place}',
    'storefront.account.pickup': 'ناخذها من الحانوت',
    'storefront.account.track': 'وين وصلت الطلبية',
    'storefront.account.step.placed': 'وصلت',
    'storefront.account.step.confirmed': 'تأكّدت',
    'storefront.account.step.shipped': 'تبعتت',
    'storefront.account.step.delivered': 'تسلّمت',
    'storefront.account.step.cancelled': 'تلغات',
    'storefront.account.step.returned': 'ترجّعت',
    'storefront.account.items': 'السلعة',
    'storefront.account.payment.pending': 'مستنية',
    'storefront.account.payment.paid': 'تخلّصت',
    'storefront.account.payment.refunded': 'ترجّعت الفلوس',
    'storefront.account.returnStep.reason': 'العلاش',
    'storefront.account.returnStep.items': 'شنوّة',
    'storefront.account.returnStep.details': 'فسّر للحانوت',
    'storefront.account.returnReason.damaged': 'مخسورة ولاّ موش كيما توقّعت',
    'storefront.account.returnReason.wrong': 'سلعة غالطة',
    'storefront.account.returnReason.mind': 'بدّلت رأيي',
    'storefront.account.returnReason.other': 'سبب آخر',
    'storefront.account.returnWhole': 'الكوموند الكل',
    'storefront.account.returnReasonLabel': 'العلاش',
    'storefront.account.returnItemsLabel': 'السلعة',
    'storefront.account.commentTitle': 'مساج على الكوموند هاذي',
    'storefront.account.commentHint': 'الحانوت كان يشوفو. ما يتنشرش.',
    'storefront.account.commentSend': 'ابعث المساج',
    'storefront.account.commentSent': 'المساج متاعك تبعث للحانوت.',
    'admin.order.returnRequest': 'طلب الرجوع',
    'admin.order.returnRequest.none': 'ما فما حتى طلب رجوع.',
    'admin.order.returnRequest.acceptHint': 'تسجيل الرجوع يقبل الطلب هذا.',
    'admin.order.returnRequest.decline': 'ارفض الطلب',
    'admin.order.returnRequest.declineNote': 'علاش ترفض',
    'admin.order.returnRequest.message': 'المساج متاع الكليان',
    'admin.order.returnRequest.status.requested': 'مستني',
    'admin.order.returnRequest.status.accepted': 'تقبل',
    'admin.order.returnRequest.status.declined': 'ترفض',
};
//# sourceMappingURL=aeb.js.map